"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[207],{

/***/ 46055:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _core_constants_app_meta_data__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(80311);
/* harmony import */ var _core_seo_AppSeo__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41252);




var AppHead = function(param) {
    var title = param.title, description = param.description, openGraph = param.openGraph;
    var seoTitle = (title ? "".concat(title, " | ") : "") + _core_constants_app_meta_data__WEBPACK_IMPORTED_MODULE_2__/* .AppMetaData.APP_NAME */ .G.APP_NAME;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_core_seo_AppSeo__WEBPACK_IMPORTED_MODULE_3__/* .AppSeo */ .R, {
        title: seoTitle,
        description: description,
        openGraph: openGraph || null
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (AppHead);


/***/ }),

/***/ 48804:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ LinkButton; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95117);
/* harmony import */ var _mantine_next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8798);




var LinkButton = function(param) {
    var title = param.title, route = param.route;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .x, {
        size: "sm",
        variant: "link",
        component: _mantine_next__WEBPACK_IMPORTED_MODULE_3__/* .NextLink */ .p,
        href: route,
        title: title,
        children: title
    });
};


/***/ }),

/***/ 7350:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MR": function() { return /* binding */ SUCCESS; },
/* harmony export */   "ig": function() { return /* binding */ FAILED; },
/* harmony export */   "pn": function() { return /* binding */ ERROR; }
/* harmony export */ });
var SUCCESS = "SUCCESS";
var FAILED = "FAILED";
var ERROR = "ERROR";


/***/ }),

/***/ 81819:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(828);
/* harmony import */ var jotai__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15103);
/* harmony import */ var jotai__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(48583);
/* harmony import */ var _core_router_AppRoutes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(84396);
/* harmony import */ var _mantine_hooks__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5686);




var lastRouteAtom = (0,jotai__WEBPACK_IMPORTED_MODULE_1__/* .atom */ .cn)(_core_router_AppRoutes__WEBPACK_IMPORTED_MODULE_0__/* .AppRoutes.HOME */ .$w.HOME);
/**
 *
 * This is single source of truth for the app state related data.
 *
 * */ // TODO: MOVE ALERT STUFF TO IT'S OWN PLACE
var useAppData = function() {
    // HREF FIX
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_mantine_hooks__WEBPACK_IMPORTED_MODULE_3__/* .useLocalStorage */ ._)({
        key: "last-page"
    }), 2), lastPage = ref[0], setLastPage = ref[1];
    // NEED TO KEEP AN EYE ON THIS - NOT BEHAVING AFTER UPDATES
    //<editor-fold desc="LAST ROUTE">
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,jotai__WEBPACK_IMPORTED_MODULE_4__/* .useAtom */ .KO)(lastRouteAtom), 2), _lastRoute = ref1[0], _setLastRoute = ref1[1];
    var getLastRoute = function() {
        return _lastRoute;
    };
    var setLastRoute = function(route) {
        return _setLastRoute(route);
    };
    //</editor-fold>
    return {
        getLastRoute: getLastRoute,
        setLastRoute: setLastRoute,
        setLastPage: setLastPage,
        lastPage: lastPage // <---- IN ACTIVE USE
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useAppData);


/***/ }),

/***/ 71992:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ useLocalStorage; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82670);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


function useLocalStorage(key, initialValue) {
    var sync = (arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}).sync;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(function() {
        var result;
        try {
            var item = window.localStorage.getItem(key);
            result = item ? JSON.parse(item) : initialValue;
        } catch (e) {
            result = initialValue;
        }
        return result;
    }), storedValue = ref[0], setStoredValue = ref[1];
    var setValue = function(valueOrCb) {
        setStoredValue(valueOrCb);
        var valueToStore = (0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(valueOrCb, Function) ? valueOrCb(storedValue) : valueOrCb;
        try {
            window.localStorage.setItem(key, JSON.stringify(valueToStore));
        } catch (e) {
            console.warn("Could not save ".concat(key, " to localStorage"));
        }
    };
    var onStorage = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(event) {
        if (event.key !== key) return;
        try {
            var item = event.newValue;
            if (item) {
                // @todo: should we validate the value here?
                setStoredValue(JSON.parse(item));
            }
        } catch (e) {
            console.warn("Could not update value for ".concat(key));
        }
    }, [
        key
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (sync) {
            window.addEventListener("storage", onStorage);
            return function() {
                window.removeEventListener("storage", onStorage);
            };
        }
        return undefined;
    }, [
        onStorage,
        sync
    ]);
    return [
        storedValue,
        setValue
    ];
}


/***/ }),

/***/ 96682:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ NotificationType; }
/* harmony export */ });
/* harmony import */ var _mantine_notifications__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74922);

var NotificationType;
(function(NotificationType) {
    NotificationType[NotificationType["INFO"] = 0] = "INFO";
    NotificationType[NotificationType["ERROR"] = 1] = "ERROR";
    NotificationType[NotificationType["SUCCESS"] = 2] = "SUCCESS";
    NotificationType[NotificationType["FAIL"] = 3] = "FAIL";
    NotificationType[NotificationType["WARNING"] = 4] = "WARNING";
})(NotificationType || (NotificationType = {}));
function getConfigs(type) {
    var notificationConfigs = {
        title: "NO IDEA",
        color: "red",
        style: function(theme) {
            return {
                root: {
                    backgroundColor: theme.white
                },
                title: {
                    color: theme.colors.error[0]
                },
                description: {
                    color: theme.colors.error[0]
                }
            };
        }
    };
    switch(type){
        case NotificationType.INFO:
            notificationConfigs = {
                title: "Information",
                color: "blue",
                style: function(theme) {
                    return {
                        root: {
                            backgroundColor: theme.white
                        },
                        title: {
                            color: theme.colors.info[0]
                        },
                        description: {
                            color: theme.colors.info[0]
                        }
                    };
                }
            };
            break;
        case NotificationType.ERROR:
            notificationConfigs = {
                title: "Error",
                color: "red",
                style: function(theme) {
                    return {
                        root: {
                            backgroundColor: theme.white
                        },
                        title: {
                            color: theme.colors.error[0]
                        },
                        description: {
                            color: theme.colors.error[0]
                        }
                    };
                }
            };
            break;
        case NotificationType.SUCCESS:
            notificationConfigs = {
                title: "Success",
                color: "green",
                style: function(theme) {
                    return {
                        root: {
                            backgroundColor: theme.white
                        },
                        title: {
                            color: theme.colors.success[0]
                        },
                        description: {
                            color: theme.colors.success[0]
                        }
                    };
                }
            };
            break;
        case NotificationType.FAIL:
            notificationConfigs = {
                title: "Failed",
                color: "orange",
                style: function(theme) {
                    return {
                        root: {
                            backgroundColor: theme.white
                        },
                        title: {
                            color: theme.colors.error[0]
                        },
                        description: {
                            color: theme.colors.error[0]
                        }
                    };
                }
            };
            break;
        case NotificationType.WARNING:
            notificationConfigs = {
                title: "Warning",
                color: "orange",
                style: function(theme) {
                    return {
                        root: {
                            backgroundColor: theme.white
                        },
                        title: {
                            color: theme.colors.warning[0]
                        },
                        description: {
                            color: theme.colors.warning[0]
                        }
                    };
                }
            };
            break;
        default:
    }
    return notificationConfigs;
}
function useNotification() {
    var notify = function notify(type, message, autoClose, onClose) {
        (0,_mantine_notifications__WEBPACK_IMPORTED_MODULE_0__/* .showNotification */ .c0)({
            title: getConfigs(type).title,
            message: message,
            autoClose: autoClose,
            color: getConfigs(type).color,
            //styles: getConfigs(type).style,
            onClose: function(props) {
                if (onClose) {
                    onClose();
                }
            }
        });
    };
    var showUserProfileStatusNotification = function showUserProfileStatusNotification(_title, message, _color, _icon, onClose) {
        (0,_mantine_notifications__WEBPACK_IMPORTED_MODULE_0__/* .cleanNotifications */ .HN)();
        (0,_mantine_notifications__WEBPACK_IMPORTED_MODULE_0__/* .showNotification */ .c0)({
            id: "profileStatusNotify",
            title: _title,
            message: message,
            autoClose: false,
            disallowClose: false,
            icon: _icon,
            color: _color,
            //styles: _style,
            onClose: function(props) {
                if (onClose) {
                    onClose();
                }
            }
        });
    };
    var showLoginErrorNotification = function showLoginErrorNotification(_message) {
        (0,_mantine_notifications__WEBPACK_IMPORTED_MODULE_0__/* .showNotification */ .c0)({
            title: "Error",
            message: _message,
            autoClose: 2000,
            styles: function(theme) {
                return {
                    root: {
                        backgroundColor: theme.white
                    },
                    title: {
                        color: theme.colors.error[0]
                    },
                    description: {
                        color: theme.colors.error[0]
                    }
                };
            }
        });
    };
    return {
        notify: notify,
        showUserProfileStatusNotification: showUserProfileStatusNotification,
        showLoginErrorNotification: showLoginErrorNotification
    };
}
/* harmony default export */ __webpack_exports__["Z"] = (useNotification);


/***/ }),

/***/ 71087:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

function createSafeContext() {
    var useContext = function useContext() {
        var value = react__WEBPACK_IMPORTED_MODULE_0__.useContext(context);
        if (value === undefined) {
            throw new Error("useContext must be inside a Provider with a value");
        }
        return value;
    };
    var context = react__WEBPACK_IMPORTED_MODULE_0__.createContext(undefined);
    return [
        useContext,
        context.Provider
    ];
}
/* harmony default export */ __webpack_exports__["Z"] = (createSafeContext);


/***/ }),

/***/ 74797:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ layouts_AppLayout; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@mantine/hooks/esm/use-local-storage/use-local-storage.js + 1 modules
var use_local_storage = __webpack_require__(5686);
// EXTERNAL MODULE: ./node_modules/@mantine/hooks/esm/use-hotkeys/use-hotkeys.js + 1 modules
var use_hotkeys = __webpack_require__(76579);
// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/theme/ColorSchemeProvider.js
var ColorSchemeProvider = __webpack_require__(36972);
// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/theme/MantineProvider.js + 4 modules
var MantineProvider = __webpack_require__(64761);
// EXTERNAL MODULE: ./node_modules/@mantine/modals/esm/ModalsProvider.js + 5 modules
var ModalsProvider = __webpack_require__(4080);
// EXTERNAL MODULE: ./node_modules/@mantine/notifications/esm/NotificationsProvider/NotificationsProvider.js + 19 modules
var NotificationsProvider = __webpack_require__(3350);
// EXTERNAL MODULE: ./src/core/router/AppRoutes.ts
var AppRoutes = __webpack_require__(84396);
;// CONCATENATED MODULE: ./src/core/config/AppThemeConfigs.ts
// THIS FILE IS LAYOUT DEPENDENT
// THE COMMENTED STUFF IS WHAT IS AVAILABLE TO CONFIGURE
var AppThemeConfigs = {
    // Object of arrays with 10 colors
    colors: {
        // 'ocean-blue': ['#7AD1DD', '#5FCCDB', '#44CADC', '#2AC9DE', '#1AC2D9', '#11B7CD', '#09ADC3', '#0E99AC', '#128797', '#147885'],
        // 'bright-pink': ['#F0BBDD', '#ED9BCF', '#EC7CC3', '#ED5DB8', '#F13EAF', '#F71FA7', '#FF00A1', '#E00890', '#C50E82', '#AD1374'],
        // NOTE: This is our own oranges
        // 'orange': ['#FFCC80', '#FFB74D', '#FFA726', '#FFA726', '#FFCA28', '#F39C12', '#FF8F00', '#FFA000', '#FF8F00', '#FF6F00'],
        // Note: This is system oranges with our changes to 6-9
        "orange": [
            "#fff4e6",
            "#ffe8cc",
            "#ffd8a8",
            "#ffc078",
            "#ffa94d",
            "#ff922b",
            "#f39c12",
            "#ff8f00",
            "#f39c12",
            "#ff8f00"
        ],
        brand: [
            "#fd823e",
            "#f39c12",
            "#474b54",
            "#4ec5a5",
            "#34558b",
            "#eff0f1"
        ],
        primary: [
            "#ff5800"
        ],
        secondary: [
            "#00A7F4"
        ],
        success: [
            "#157347"
        ],
        info: [
            "#373737"
        ],
        warning: [
            "#ffca2c"
        ],
        danger: [
            "#dc3545"
        ],
        error: [
            "#dc3545"
        ]
    },
    // White and black colors, defaults to '#fff' and '#000'
    white: "#fff",
    black: "#000",
    primaryColor: "orange",
    // Controls focus ring styles:
    // auto – display focus ring only when user navigates with keyboard (default)
    // always – display focus ring when user navigates with keyboard and mouse
    // never – focus ring is always hidden (not recommended)
    focusRing: "auto",
    // Determines whether motion based animations should be disabled for
    // users who prefer to reduce motion in their OS settings
    respectReducedMotion: false,
    // Determines whether elements that do not have pointer cursor by default
    // (checkboxes, radio, native select) should have it ['default' | 'pointer']
    cursorType: "default",
    // Default border-radius used for most elements ['xs' | 'sm' | 'md' | 'lg' | 'xl' | number]
    defaultRadius: "md",
    // Key of theme.colors
    // primaryColor: '#cc0f0f',
    // primaryColor: 'orange',
    // THIS WILL RESUlT IN ERROR, DO NOT DO THIS
    // primaryColor: '#EC45EE',
    // Index of color from theme.colors that is considered primary, Shade type is 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9
    // primaryShade: 1,
    // primaryShade: { light: 6, dark: 8 },
    // Default gradient used in components that support `variant="gradient"` (Button, ThemeIcon, etc.)
    // defaultGradient: { deg: 0, from: 'pink', to: 'orange' },
    defaultGradient: {
        from: "orange",
        to: "yellow",
        deg: 30
    },
    // font-family and line-height used in most components
    fontFamily: "Montserrat",
    // lineHeight: string | number,
    // Monospace font-family, used in Code, Kbd and Prism components
    fontFamilyMonospace: "Monaco, Courier, monospace",
    // Timing function used for animations, defaults to 'ease'
    transitionTimingFunction: "ease",
    // Sizes for corresponding properties ['xs' | 'sm' | 'md' | 'lg' | 'xl', number]
    fontSizes: {
        xs: 10,
        sm: 12
    },
    radius: {
        xs: 6,
        sm: 8
    },
    spacing: {
        xs: 4
    },
    // Values used for box-shadow  ['xs' | 'sm' | 'md' | 'lg' | 'xl', string]
    shadows: {
        sm: "rgba(0, 0, 0, 0.16) 0px 2px 4px"
    },
    // Breakpoints used in some components to add responsive styles
    breakpoints: {
        xxs: 400,
        xs: 500,
        sm: 800,
        md: 1000,
        lg: 1200,
        xl: 4000
    },
    // h1-h6 styles, used in Title and TypographyStylesProvider components
    // properties for all headings
    headings: {
        fontFamily: "Montserrat",
        fontWeight: 300,
        // properties for individual headings, all of them are optional
        sizes: {
            h1: {
                fontSize: 24,
                lineHeight: 1.5
            },
            h2: {
                fontSize: 16,
                lineHeight: 2
            }
        }
    },
    // Default loader used in Loader and LoadingOverlay components ['oval' | 'bars' | 'dots',]
    loader: "bars",
    // Add your own custom properties on Mantine theme
    other: {
        maxWidth: 1200,
        myCustomProp: "ACCESS ME ANYWHERE WHERE YOU CAN ACCESS THEME OBJ"
    }
};

;// CONCATENATED MODULE: ./src/core/config/DirectionContext.tsx

var DirectionContext = /*#__PURE__*/ (0,react.createContext)("rtl");

// EXTERNAL MODULE: ./node_modules/stylis-plugin-rtl/dist/stylis-rtl.js
var stylis_rtl = __webpack_require__(14194);
// EXTERNAL MODULE: ./node_modules/@emotion/cache/dist/emotion-cache.browser.esm.js + 2 modules
var emotion_cache_browser_esm = __webpack_require__(9463);
;// CONCATENATED MODULE: ./src/core/config/rtl-cache.js


var rtlCache = (0,emotion_cache_browser_esm/* default */.Z)({
    key: "mantine-rtl",
    prepend: true,
    stylisPlugins: [
        stylis_rtl/* default */.Z
    ]
});

// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Container/Container.js + 1 modules
var Container = __webpack_require__(72445);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Paper/Paper.js + 1 modules
var Paper = __webpack_require__(82623);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Loader/Loader.js + 3 modules
var Loader = __webpack_require__(20966);
// EXTERNAL MODULE: ./node_modules/next-auth/react/index.js
var next_auth_react = __webpack_require__(33299);
// EXTERNAL MODULE: ./src/core/hooks/use-app-data.ts
var use_app_data = __webpack_require__(81819);
;// CONCATENATED MODULE: ./src/core/layouts/Functional/AuthGuard.tsx







var AuthGuard = function(param) {
    var children = param.children;
    var ref;
    //const [opened, setOpened] = useState(false);
    var router = (0,next_router.useRouter)();
    var setLastPage = (0,use_app_data/* default */.Z)().setLastPage;
    var session = (0,next_auth_react.useSession)();
    var isUser = !!(session === null || session === void 0 ? void 0 : (ref = session.data) === null || ref === void 0 ? void 0 : ref.user);
    (0,react.useEffect)(function() {
        if ((session === null || session === void 0 ? void 0 : session.status) === "loading") return;
        // IF NOT AUTHENTICATED SEND HIM TO LOGIN
        // there is no user
        if (!isUser) {
            //setOpened(true);
            /*showNotification({
                title: 'Default notification',
                message: 'Nop',
            })*/ /*setTimeout(
                () =>
                    openContextModal({
                        modal: 'authGuardModal',
                        innerProps: {},
                    }),
                1,
            );*/ if (router.route !== AppRoutes/* AppRoutes.LOGIN */.$w.LOGIN) {
                // setLastRoute(router.route);
                setLastPage(router.asPath);
            }
            router.push(AppRoutes/* AppRoutes.LOGIN */.$w.LOGIN).catch(function() {
                return console.error("Unable to Route");
            });
        }
    }, [
        session,
        isUser,
        router
    ]);
    /*if (loading || !hasUser) {
        return (
            <div>
                <Modal
                    centered={true}
                    opened={opened}
                    withCloseButton={false}
                    onClose={() => setOpened(false)}
                    title="Information"
                    overlayColor="#373737"
                    overlayOpacity={0.55}
                    overlayBlur={3}
                    transition="fade"
                    transitionDuration={300}
                    transitionTimingFunction="ease"
                    closeOnEscape={false}
                    closeOnClickOutside={false}
                >
                    BUTTON HERE TO SHOW LOGIN BUTTON WHEN CLICKED ON LOGIN OPEN ACTUAL LOGIN FORM
                </Modal>
            </div>
        );
    }*/ if (isUser) {
        return children;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* Container */.W, {
        style: {
            margin: "0 auto",
            maxWidth: 1200,
            paddingLeft: 20,
            paddingRight: 20
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Paper/* Paper */.X, {
            mt: 30,
            style: {
                textAlign: "center"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader/* Loader */.a, {
                color: "#f39c12",
                variant: "dots",
                size: "sm"
            })
        })
    });
};
/* harmony default export */ var Functional_AuthGuard = (AuthGuard);

// EXTERNAL MODULE: ./src/core/hooks/useSafeContext.ts
var useSafeContext = __webpack_require__(71087);
;// CONCATENATED MODULE: ./src/core/providers/AppStateProvider.tsx



var APP_STATE_KEYS = {
    dummy: "DUMMY"
};
var ref = (0,_sliced_to_array/* default */.Z)((0,useSafeContext/* default */.Z)(), 2);
var useAppState = ref[0], Provider = ref[1];
var AppStateProvider = function(param) {
    var children = param.children;
    /*const [selectedImageIndex, setSelectedImageIndex] =
        useLocalStorage(APP_STATE_KEYS.count, '0', { sync: true });*/ // const [dummyData, setDummyData] = useLocalStorage(APP_STATE_KEYS.test double, "", {sync: true});
    var providerValues = {
        counter: 4146
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Provider, {
        value: providerValues,
        children: children
    });
};

// EXTERNAL MODULE: ./src/core/providers/PropertyStateProvider.tsx
var PropertyStateProvider = __webpack_require__(86727);
// EXTERNAL MODULE: ./src/core/providers/BookingStateProvider.tsx + 1 modules
var BookingStateProvider = __webpack_require__(97771);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/AppShell/Header/Header.js + 5 modules
var Header = __webpack_require__(43643);
// EXTERNAL MODULE: ./node_modules/@mantine/next/esm/NextLink.js
var NextLink = __webpack_require__(8798);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./src/core/components/common/CActionImage.tsx





var CActionImage = function(param) {
    var route = param.route, onClick = param.onClick, dark = param.dark, light = param.light, height = param.height, width = param.width, alt = param.alt, className = param.className;
    var colorScheme = (0,MantineProvider/* useMantineTheme */.rZ)().colorScheme;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* NextLink */.p, {
        className: className,
        href: route || "#",
        onClick: onClick,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
            width: width,
            height: height,
            src: colorScheme === "dark" ? dark : light,
            alt: alt
        })
    });
};

;// CONCATENATED MODULE: ./public/icons/dxbstay-light-logo.svg
/* harmony default export */ var dxbstay_light_logo = ({"src":"/_next/static/media/dxbstay-light-logo.fd8cb341.svg","height":139,"width":501});
;// CONCATENATED MODULE: ./public/icons/dxbstay-dark-logo.svg
/* harmony default export */ var dxbstay_dark_logo = ({"src":"/_next/static/media/dxbstay-dark-logo.ca8a8fbc.svg","height":139,"width":503});
;// CONCATENATED MODULE: ./src/core/layouts/AppLogo.tsx






var AppLogo = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CActionImage, {
        route: AppRoutes/* AppRoutes.HOME */.$w.HOME,
        light: dxbstay_light_logo,
        dark: dxbstay_dark_logo,
        width: 182,
        height: 50,
        alt: "DXB Stay - Vacation Rentals Portal"
    });
};

// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/tss/create-styles.js + 1 modules
var create_styles = __webpack_require__(56817);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Group/Group.js + 1 modules
var Group = __webpack_require__(71232);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
;// CONCATENATED MODULE: ./src/core/layouts/Menu/MenuButtons.styles.ts


/* harmony default export */ var MenuButtons_styles = ((0,create_styles/* createStyles */.k)(function(theme) {
    return {
        group: (0,_define_property/* default */.Z)({}, theme.fn.smallerThan("sm"), {
            display: "none"
        }),
        links: (0,_define_property/* default */.Z)({}, theme.fn.smallerThan("xs"), {
            display: "none"
        }),
        link: {
            display: "block",
            lineHeight: 1,
            padding: "11px 20px",
            borderRadius: theme.radius.sm,
            // borderStyle: "solid",
            // borderWidth: 1,
            // borderColor: theme.colors.gray[3],
            textDecoration: "none",
            color: theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.colors.gray[7],
            fontSize: theme.fontSizes.sm,
            fontWeight: 400,
            "&:hover": {
                backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.colors.gray[0],
                color: theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.colors.gray[7],
                transition: "background-color 0.3s ease-in-out"
            }
        }
    };
}));

;// CONCATENATED MODULE: ./src/core/layouts/Menu/App/AppMenuButtons.tsx





// USE IT WHEN YOU HAVE QUIET A FEW OF SAME TYPE OF BUTTONS
var AppMenuButtons = function() {
    var ref = MenuButtons_styles(), classes = ref.classes, cx = ref.cx;
    // IF YOU WANT A BUTTON TO BE ACTIVE ON SELECTION
    // const [active, setActive] = useState("");
    var menuButtons = AppRoutes/* AppMenuLinks.map */.Hv.map(function(route) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            href: route.link,
            title: route.label,
            "aria-label": route.label,
            className: cx(classes.link),
            children: route.label
        }, route.label);
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* Container */.W, {
        px: 6,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Group/* Group */.Z, {
            className: classes.group,
            children: menuButtons
        })
    });
};

// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Menu/Menu.js + 15 modules
var Menu = __webpack_require__(66991);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Text/Text.js + 1 modules
var Text = __webpack_require__(95117);
// EXTERNAL MODULE: ./node_modules/@tabler/icons/icons-react/dist/index.esm.js
var index_esm = __webpack_require__(63991);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/UnstyledButton/UnstyledButton.js + 1 modules
var UnstyledButton = __webpack_require__(34736);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Avatar/Avatar.js + 5 modules
var Avatar = __webpack_require__(99985);
// EXTERNAL MODULE: ./src/core/utils/dxb-utils.ts
var dxb_utils = __webpack_require__(10646);
;// CONCATENATED MODULE: ./src/core/layouts/Menu/User/UserAvatar.tsx








var styles = function(theme) {
    return {
        display: "block",
        // width: '100%',
        // padding: 2,
        paddingRight: 8,
        borderRadius: theme.radius.sm,
        borderWidth: 1,
        borderColor: theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[2],
        borderStyle: "solid",
        color: theme.colorScheme === "dark" ? theme.white : theme.colors.dark[9],
        backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.white,
        "&:hover": {
            backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.colors.gray[0],
            boxShadow: theme.shadows.sm,
            borderColor: theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[2],
            transition: "box-shadow 0.1s ease-in"
        }
    };
};
var UserAvatar = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) {
    var name = _param.name, email = _param.email, image = _param.image, icon = _param.icon, theme = _param.theme, others = (0,_object_without_properties/* default */.Z)(_param, [
        "name",
        "email",
        "image",
        "icon",
        "theme"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(UnstyledButton/* UnstyledButton */.k, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        ref: ref,
        sx: styles
    }, others), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
            spacing: "xs",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* Avatar */.q, {
                    size: 32,
                    src: image,
                    radius: "sm"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: {
                        flex: 1
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                        size: "sm",
                        weight: 400,
                        children: (0,dxb_utils/* displayAvatarName */.z0)(name)
                    })
                }),
                icon || /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* IconChevronRight */.VG8, {
                    color: theme.colorScheme === "dark" ? theme.colors.gray[0] : theme.colors.dark[9],
                    stroke: 1,
                    size: 18
                })
            ]
        })
    }));
/*return (
        <UnstyledButton ref={ref} sx={styles} {...others}>
            <Group spacing={7}>
                <Avatar src={image} alt={name} radius="xl" size={20}/>

                <Text weight={500} size="sm" sx={{ lineHeight: 1 }} mr={3}>
                    {name}
                </Text>

                <IconChevronDown size={12} stroke={1.5}/>
            </Group>
        </UnstyledButton>
    )*/ });

;// CONCATENATED MODULE: ./src/core/layouts/Menu/Auth/AuthMenuButtons.tsx







var AuthMenuButtons = function() {
    var colors = (0,MantineProvider/* useMantineTheme */.rZ)().colors;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* Container */.W, {
        px: 0,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Group/* Group */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Menu/* Menu */.v, {
                width: 150,
                "aria-label": "main menu",
                position: "bottom-end",
                transition: "pop-top-right",
                radius: "xs",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu/* Menu.Target */.v.Target, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UserAvatar, {
                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* IconMenu2 */._AG, {
                                size: 18,
                                color: colors.gray[6]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Menu/* Menu.Dropdown */.v.Dropdown, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu/* Menu.Item */.v.Item, {
                                p: 10,
                                component: NextLink/* NextLink */.p,
                                href: AppRoutes/* AppRoutes.LOGIN */.$w.LOGIN,
                                title: "Log in",
                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* IconLockOpen */.e0r, {
                                    size: 20,
                                    color: colors.gray[6]
                                }),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                    ml: 6,
                                    size: "sm",
                                    weight: 400,
                                    children: "Log in"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu/* Menu.Divider */.v.Divider, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu/* Menu.Item */.v.Item, {
                                p: 10,
                                component: NextLink/* NextLink */.p,
                                href: AppRoutes/* AppRoutes.REGISTER */.$w.REGISTER,
                                title: "Sign up",
                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* IconUserPlus */.$4n, {
                                    size: 20,
                                    color: colors.gray[6]
                                }),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                    ml: 6,
                                    size: "sm",
                                    weight: 400,
                                    children: "Sign up"
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/core/layouts/Menu/Auth/AuthMenu.tsx





var AuthMenu = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* Container */.W, {
        px: 0,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(AppMenuButtons, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthMenuButtons, {})
            ]
        })
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./src/features/common/hooks/use-user-data.ts
var use_user_data = __webpack_require__(85992);
;// CONCATENATED MODULE: ./src/core/layouts/Menu/LogoutButton.tsx
/* provided dependency */ var process = __webpack_require__(83454);










var LogoutButton = function() {
    var ref = (0,use_user_data/* default */.Z)(), clearUserProfileData = ref.clearUserProfileData, clearUserPropIds = ref.clearUserPropIds;
    var ref1 = (0,BookingStateProvider/* useBookingState */.hg)(), resetPrices = ref1.resetPrices, resetBookingInfo = ref1.resetBookingInfo; // LOCAL CALCULATIONS
    var setLastPage = (0,use_app_data/* default */.Z)().setLastPage;
    var onLogout = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        clearUserProfileData();
                        clearUserPropIds();
                        resetBookingInfo();
                        resetPrices();
                        setLastPage(AppRoutes/* AppRoutes.HOME */.$w.HOME);
                        return [
                            4,
                            (0,next_auth_react.signOut)({
                                callbackUrl: process.env.NEXTAUTH_URL || "http://localhost:8080"
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function onLogout() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
        title: "Logout",
        onClick: onLogout,
        ml: 6,
        size: "sm",
        weight: 400,
        children: "Logout"
    });
};

// EXTERNAL MODULE: ./src/core/utils/network-utils.ts
var network_utils = __webpack_require__(41448);
;// CONCATENATED MODULE: ./src/core/layouts/Menu/User/UserMenuButtons.tsx











var UserMenuButtons = function() {
    var colors = (0,MantineProvider/* useMantineTheme */.rZ)().colors;
    var getUserProfileData = (0,use_user_data/* default */.Z)().getUserProfileData;
    var ref = getUserProfileData(), image = ref.image, name = ref.name, email = ref.email;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* Container */.W, {
        px: 0,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Group/* Group */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Menu/* Menu */.v, {
                width: 250,
                "aria-label": "user menu",
                position: "bottom-end",
                // transition="pop-top-right"
                trigger: "click",
                radius: "xs",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu/* Menu.Target */.v.Target, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UserAvatar, {
                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* IconMenu2 */._AG, {
                                size: 18,
                                color: colors.gray[6]
                            }),
                            image: image !== null ? "".concat(network_utils/* S3_USER_BUCKET_URL */.gK, "/").concat(image, "?ttl=").concat((0,network_utils/* generateKey */.HI)()) : null,
                            name: (0,dxb_utils/* displayAvatarName */.z0)(name),
                            email: email
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Menu/* Menu.Dropdown */.v.Dropdown, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu/* Menu.Item */.v.Item, {
                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* IconUser */.f7T, {
                                    size: 20
                                }),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    style: {
                                        flex: 1,
                                        marginLeft: 6
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                            size: "sm",
                                            weight: 400,
                                            children: name
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                            color: "dimmed",
                                            size: "xs",
                                            children: email
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu/* Menu.Divider */.v.Divider, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu/* Menu.Item */.v.Item, {
                                p: 10,
                                component: NextLink/* NextLink */.p,
                                href: AppRoutes/* AppRoutes.FAVORITES */.$w.FAVORITES,
                                title: "Favorites",
                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* IconHeart */.AUh, {
                                    size: 20,
                                    color: colors.red[6]
                                }),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                    ml: 6,
                                    size: "sm",
                                    weight: 400,
                                    children: "Favorites"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu/* Menu.Item */.v.Item, {
                                p: 10,
                                component: NextLink/* NextLink */.p,
                                href: AppRoutes/* AppRoutes.BOOKINGS */.$w.BOOKINGS,
                                title: "Bookings",
                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* IconStar */.GK, {
                                    size: 20,
                                    color: colors.yellow[6]
                                }),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                    ml: 6,
                                    size: "sm",
                                    weight: 400,
                                    children: "Bookings"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu/* Menu.Divider */.v.Divider, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu/* Menu.Item */.v.Item, {
                                p: 10,
                                component: NextLink/* NextLink */.p,
                                href: AppRoutes/* AppRoutes.ACCOUNT */.$w.ACCOUNT,
                                title: "Account Settings",
                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* IconSettings */.iCC, {
                                    size: 20,
                                    color: colors.blue[6]
                                }),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                    ml: 6,
                                    size: "sm",
                                    weight: 400,
                                    children: "Account Settings"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu/* Menu.Item */.v.Item, {
                                p: 10,
                                component: NextLink/* NextLink */.p,
                                href: AppRoutes/* AppRoutes.CHANGE_PASSWORD */.$w.CHANGE_PASSWORD,
                                title: "Change Password",
                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* IconLock */._V1, {
                                    size: 20,
                                    color: colors.green[6]
                                }),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                    ml: 6,
                                    size: "sm",
                                    weight: 400,
                                    children: "Change Password"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu/* Menu.Divider */.v.Divider, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu/* Menu.Item */.v.Item, {
                                p: 10,
                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* IconLogout */.gtU, {
                                    size: 20,
                                    color: colors.gray[6]
                                }),
                                closeMenuOnClick: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LogoutButton, {})
                            })
                        ]
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/core/layouts/Menu/User/UserMenu.tsx





var UserMenu = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* Container */.W, {
        px: 0,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
            spacing: 0,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(AppMenuButtons, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(UserMenuButtons, {})
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/core/layouts/Menu/App/AppMenu.tsx







var useStyles = (0,create_styles/* createStyles */.k)(function() {
    return {
        menuMainDiv: {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            height: "100%",
            // maxWidth: 1200,
            marginRight: 0,
            paddingLeft: 0,
            zIndex: 20
        }
    };
});
// THIS WILL DECIDE WHAT TO SHOW IN MENU
var AppMenu = function() {
    var classes = useStyles().classes;
    var isUser = (0,use_user_data/* default */.Z)().isUser;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* Container */.W, {
        className: classes.menuMainDiv,
        pr: 6,
        children: isUser() ? /*#__PURE__*/ (0,jsx_runtime.jsx)(UserMenu, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthMenu, {})
    });
};

;// CONCATENATED MODULE: ./src/core/layouts/Header/AppHeader.styles.ts

var HEADER_HEIGHT = 100;
/* harmony default export */ var AppHeader_styles = ((0,create_styles/* createStyles */.k)(function(theme) {
    return {
        root: {
            position: "relative",
            zIndex: 100,
            // boxShadow: theme.shadows.sm,
            // marginBottom: 30,
            borderBottom: 0
        },
        header: {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            height: "100%",
            // paddingLeft: 20,
            // paddingRight: 20,
            maxWidth: theme.other.maxWidth
        }
    };
}));

// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/ActionIcon/ActionIcon.js + 1 modules
var ActionIcon = __webpack_require__(49834);
;// CONCATENATED MODULE: ./src/core/layouts/ColorScheme/ColorSchemeButton.tsx




var ColorSchemeButton = function() {
    var ref = (0,ColorSchemeProvider/* useMantineColorScheme */.X)(), colorScheme = ref.colorScheme, toggleColorScheme = ref.toggleColorScheme;
    var Icon = colorScheme === "dark" ? index_esm/* IconSun */.O31 : index_esm/* IconMoon */.C9B;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Group/* Group */.Z, {
        position: "center",
        my: "xl",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionIcon/* ActionIcon */.A, {
            title: "Change Theme",
            "aria-label": "Dark / Light Theme",
            variant: "outline",
            onClick: function() {
                return toggleColorScheme();
            },
            size: "lg",
            sx: function(theme) {
                return {
                    backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.colors.gray[0],
                    color: theme.colorScheme === "dark" ? theme.colors.orange[4] : theme.colors.gray[6],
                    borderColor: theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[4]
                };
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                size: "1.5rem",
                stroke: 1.2
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/core/layouts/Header/AppHeader.tsx







var AppHeader = function() {
    var classes = AppHeader_styles().classes;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* Header */.h, {
        height: HEADER_HEIGHT,
        className: classes.root,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* Container */.W, {
            className: classes.header,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(AppLogo, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(AppMenu, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ColorSchemeButton, {})
            ]
        })
    });
};

// EXTERNAL MODULE: ./src/core/components/common/LinkButton.tsx
var LinkButton = __webpack_require__(48804);
;// CONCATENATED MODULE: ./src/core/components/common/CActionIcon.tsx




var CActionIcon = function(param) {
    var route = param.route, onClick = param.onClick, dark = param.dark, light = param.light, target = param.target, title = param.title;
    var colorScheme = (0,MantineProvider/* useMantineTheme */.rZ)().colorScheme;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* NextLink */.p, {
        title: title,
        target: target,
        href: route || "#",
        onClick: onClick,
        children: colorScheme === "dark" ? dark : light
    });
};

// EXTERNAL MODULE: ./src/core/constants/app-meta-data.ts + 1 modules
var app_meta_data = __webpack_require__(80311);
;// CONCATENATED MODULE: ./src/core/layouts/Footer/AppFooter.styles.ts


/* harmony default export */ var AppFooter_styles = ((0,create_styles/* createStyles */.k)(function(theme) {
    var _obj, _obj1, _obj2;
    return {
        /* footer: {
        color: theme.colors.gray[6],
        // marginTop: 30,
        paddingLeft: 42,
        paddingRight: 42,
        // borderTop: `1px solid ${theme.colorScheme === 'dark' ? theme.colors.dark[5] : theme.colors.gray[2]}`,
    },*/ inner: (0,_define_property/* default */.Z)({
            minHeight: 100,
            maxWidth: theme.other.maxWidth,
            fontSize: theme.fontSizes.sm,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            paddingTop: theme.spacing.xl,
            paddingBottom: theme.spacing.xl
        }, theme.fn.smallerThan("sm"), {
            flexDirection: "column"
        }),
        links: (_obj = {}, (0,_define_property/* default */.Z)(_obj, theme.fn.smallerThan("sm"), {
            marginTop: theme.spacing.md,
            width: "100%",
            justifyContent: "center"
        }), (0,_define_property/* default */.Z)(_obj, "a", {
            color: theme.colorScheme === "dark" ? theme.colors.gray[0] : theme.colors.gray[7]
        }), (0,_define_property/* default */.Z)(_obj, "a:hover", {
            color: theme.colors.orange[5],
            textDecoration: "none"
        }), (0,_define_property/* default */.Z)(_obj, "width", "33.33%"), (0,_define_property/* default */.Z)(_obj, "justifyContent", "flex-start"), _obj),
        copyright: (_obj1 = {}, (0,_define_property/* default */.Z)(_obj1, theme.fn.smallerThan("sm"), {
            marginTop: theme.spacing.md,
            width: "100%"
        }), (0,_define_property/* default */.Z)(_obj1, "color", theme.colorScheme === "dark" ? theme.colors.gray[0] : theme.colors.gray[7]), (0,_define_property/* default */.Z)(_obj1, "width", "33.33%"), (0,_define_property/* default */.Z)(_obj1, "justifyContent", "center"), (0,_define_property/* default */.Z)(_obj1, "display", "flex"), _obj1),
        social: (_obj2 = {}, (0,_define_property/* default */.Z)(_obj2, theme.fn.smallerThan("sm"), {
            marginTop: theme.spacing.md,
            width: "100%",
            justifyContent: "center"
        }), (0,_define_property/* default */.Z)(_obj2, "width", "33.33%"), (0,_define_property/* default */.Z)(_obj2, "justifyContent", "flex-end"), _obj2),
        stripe: {
            display: "inline-flex"
        },
        instagram: {
            color: theme.colorScheme === "dark" ? theme.colors.gray[0] : theme.colors.gray[7],
            height: 28,
            width: 34,
            verticalAlign: "middle",
            paddingLeft: 6,
            marginLeft: 10,
            borderLeft: 1,
            borderRight: 0,
            borderTop: 0,
            borderBottom: 0,
            borderStyle: "solid",
            borderColor: theme.colors.gray[6]
        }
    };
}));

;// CONCATENATED MODULE: ./public/icons/powered-stripe-dark.svg
/* harmony default export */ var powered_stripe_dark = ({"src":"/_next/static/media/powered-stripe-dark.d355ed8d.svg","height":34,"width":150});
;// CONCATENATED MODULE: ./public/icons/powered-stripe-light.svg
/* harmony default export */ var powered_stripe_light = ({"src":"/_next/static/media/powered-stripe-light.ed6758c0.svg","height":34,"width":150});
;// CONCATENATED MODULE: ./src/core/layouts/Footer/AppFooter.tsx












var AppFooter = function() {
    var classes = AppFooter_styles().classes;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* Container */.W, {
        className: classes.inner,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
                spacing: 40,
                className: classes.links,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkButton/* LinkButton */.Q, {
                        title: "Contact",
                        route: AppRoutes/* AppRoutes.CONTACT */.$w.CONTACT
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkButton/* LinkButton */.Q, {
                        title: "Terms",
                        route: AppRoutes/* AppRoutes.TERMS */.$w.TERMS
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkButton/* LinkButton */.Q, {
                        title: "Policies",
                        route: AppRoutes/* AppRoutes.POLICIES */.$w.POLICIES
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                className: classes.copyright,
                children: "\xa9 2023 Vacation Rentals Portal"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
                spacing: 0,
                className: classes.social,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CActionImage, {
                        className: classes.stripe,
                        route: AppRoutes/* AppRoutes.HOME */.$w.HOME,
                        light: powered_stripe_light,
                        dark: powered_stripe_dark,
                        width: 110,
                        height: 24,
                        alt: "Powered by Stripe"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CActionIcon, {
                        target: "_blank",
                        title: "Visit the DXB Stay Instagram page",
                        route: app_meta_data/* AppMetaData.INSTAGRAM */.G.INSTAGRAM,
                        light: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* IconBrandInstagram */.u9g, {
                            stroke: 1,
                            className: classes.instagram
                        }),
                        dark: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* IconBrandInstagram */.u9g, {
                            stroke: 1,
                            className: classes.instagram
                        })
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Button/Button.js + 3 modules
var Button = __webpack_require__(67841);
;// CONCATENATED MODULE: ./src/features/auth/auth-gaurd-modal/AuthGuardModal.tsx



var AuthGuardModal = function(param) {
    var context = param.context, id = param.id, innerProps = param.innerProps;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
        position: "center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                size: "sm",
                children: "You are not logged in please Login"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                variant: "filled",
                gradient: {
                    from: "indigo",
                    to: "cyan"
                },
                onClick: function() {
                    context.closeModal(id);
                // OPEN LOGIN FORM MODAL
                },
                children: "Login"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/core/layouts/AppLayout.tsx






















var THEME_KEY = "dxb-color-scheme";
var AppLayout = function(param) {
    var children = param.children, _requireAuth = param.requireAuth, requireAuth = _requireAuth === void 0 ? false : _requireAuth, _noHeader = param.noHeader, noHeader = _noHeader === void 0 ? false : _noHeader;
    //<editor-fold desc="ROUTING">
    var setLastRoute = (0,use_app_data/* default */.Z)().setLastRoute;
    var router = (0,next_router.useRouter)();
    var restrictedPath = AppRoutes/* RESTRICTED_PATHS.some */.dj.some(function(path) {
        return router.route.startsWith(path);
    });
    var authPath = AppRoutes/* AUTH_PATHS.some */.tz.some(function(path) {
        return router.route.startsWith(path);
    });
    (0,react.useEffect)(function() {
        if (!authPath) {
            setLastRoute(router.route);
        }
    }, [
        authPath
    ]);
    //</editor-fold>
    //<editor-fold desc="THEME">
    var ref = (0,react.useState)("ltr"), dir = ref[0], setDir = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,use_local_storage/* useLocalStorage */._)({
        key: THEME_KEY,
        defaultValue: "light",
        getInitialValueInEffect: true
    }), 2), colorScheme = ref1[0], setColorScheme = ref1[1];
    var toggleColorScheme = function(value) {
        return setColorScheme(value || (colorScheme === "dark" ? "light" : "dark"));
    };
    (0,use_hotkeys/* useHotkeys */.A)([
        [
            "ctrl+J",
            function() {
                return toggleColorScheme();
            }
        ]
    ]);
    //</editor-fold>
    //<editor-fold desc="RENDER">
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DirectionContext.Provider, {
            value: dir,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ColorSchemeProvider/* ColorSchemeProvider */.A, {
                colorScheme: colorScheme,
                toggleColorScheme: toggleColorScheme,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MantineProvider/* MantineProvider */.Me, {
                    // @ts-expect-error
                    theme: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, AppThemeConfigs), {
                        colorScheme: colorScheme,
                        dir: dir
                    }),
                    withGlobalStyles: true,
                    withNormalizeCSS: true,
                    emotionCache: dir === "rtl" ? rtlCache : undefined,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NotificationsProvider/* NotificationsProvider */.N, {
                        position: "top-right",
                        zIndex: 2077,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalsProvider/* ModalsProvider */.$, {
                            modals: {
                                authGuardModal: AuthGuardModal
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppStateProvider, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PropertyStateProvider/* PropertyStateProvider */.dl, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BookingStateProvider/* BookingStateProvider */.vk, {
                                        children: [
                                            !noHeader && /*#__PURE__*/ (0,jsx_runtime.jsx)(AppHeader, {}),
                                            requireAuth || restrictedPath ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Functional_AuthGuard, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                                                    style: {
                                                        minHeight: "calc(90vh - 100px)"
                                                    },
                                                    children: children
                                                })
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                                                style: {
                                                    minHeight: "calc(90vh - 100px)"
                                                },
                                                children: children
                                            }),
                                            !noHeader && /*#__PURE__*/ (0,jsx_runtime.jsx)(AppFooter, {})
                                        ]
                                    })
                                })
                            })
                        })
                    })
                })
            })
        })
    });
//</editor-fold>
};
/* harmony default export */ var layouts_AppLayout = (AppLayout);


/***/ }),

/***/ 97771:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "vk": function() { return /* binding */ BookingStateProvider; },
  "hg": function() { return /* binding */ useBookingState; }
});

// UNUSED EXPORTS: BOOKING_STATE_KEYS, Provider

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/core/hooks/useSafeContext.ts
var useSafeContext = __webpack_require__(71087);
// EXTERNAL MODULE: ./src/core/hooks/useLocalStorage.ts
var useLocalStorage = __webpack_require__(71992);
// EXTERNAL MODULE: ./src/generated/graphql.tsx
var graphql = __webpack_require__(89402);
// EXTERNAL MODULE: ./src/core/hooks/useNotification.ts
var useNotification = __webpack_require__(96682);
// EXTERNAL MODULE: ./src/features/common/hooks/use-user-data.ts
var use_user_data = __webpack_require__(85992);
// EXTERNAL MODULE: ./src/core/utils/date-utils.ts
var date_utils = __webpack_require__(54938);
// EXTERNAL MODULE: ./src/core/constants/app-consts.ts
var app_consts = __webpack_require__(7350);
// EXTERNAL MODULE: ./src/core/providers/PropertyStateProvider.tsx
var PropertyStateProvider = __webpack_require__(86727);
// EXTERNAL MODULE: ./src/core/utils/dxb-utils.ts
var dxb_utils = __webpack_require__(10646);
;// CONCATENATED MODULE: ./src/core/providers/price-rule-mappers.ts
/**
 * This is where we deal with the dxb stay pricing rules calculations
 * */ 
function mapBedRoomsText(bedroomsCount) {
    return bedroomsCount === 1 ? "Bedroom" : "Bedrooms";
}
//<editor-fold desc="CALCULATORS">
var calculateTourismFees = function(bedrooms, totalNights, fees, limit) {
    var tFees = 0;
    var maxLimit = totalNights > limit ? limit : totalNights;
    // console.log(maxLimit, "maxLimit")
    tFees = bedrooms * fees * maxLimit;
    return tFees;
};
var calculateWeeklyFees = function(range, fees, limit) {
    // console.log(range, "range")
    var startDate = range[0]; //'2022-09-01';
    var endDate = range[1]; //'2022-09-30';
    var weeksCount = (0,date_utils/* getWeeklyDates */.gS)(startDate, endDate).length;
    // console.log(weeksCount, 'weeksCount')
    var tFees = 0;
    for(var i = 0; i < weeksCount; i++){
        tFees -= fees;
    }
    return tFees;
};
//</editor-fold>
//<editor-fold desc="MAPPERS">
var mapLimitRule = function(totalNights, conditionValue, priceTypeName, amount, bedroomsCount) {
    var limit = parseInt(conditionValue, 10);
    var maxLimit = totalNights > limit ? limit : totalNights;
    var bedroomCount = bedroomsCount;
    var calculated = {
        typeName: priceTypeName,
        name: "AED ".concat(amount, " x ").concat(bedroomCount, " ").concat(mapBedRoomsText(bedroomCount), " x ").concat(maxLimit, " Nights"),
        amount: calculateTourismFees(bedroomCount, totalNights, amount, limit)
    };
    // console.log(calculated, 'TOURISM FEE')
    return calculated;
};
var mapEveryRule = function(range, conditionValue, priceTypeName, amount) {
    // THIS IS SET TO WEEKLY
    // CAN BE SET TO MONTHLY BUT THERE IS NO CHECK YET
    // THIS WILL COUNT ALL THE WEEKS IN A SELECTED RANGE
    var calculated = {
        typeName: priceTypeName,
        name: "AED ".concat(amount, " x ").concat((0,date_utils/* getWeeklyDates */.gS)(range[0], range[1]).length, " Weeks"),
        amount: calculateWeeklyFees(range, amount, parseInt(conditionValue, 10) // CURRENTLY NOT IN USE
        )
    };
    // console.log(calculated, 'WEEKLY DISCOUNT')
    return calculated;
};
// THIS RULE IS LOCKED TO SECURITY DEPOSIT
var mapUntilRule = function(priceTypeName, _amount) {
    // THIS IS BASED ON - STRIPE PAYMENT CHECK.
    // SO IF THIS IS IN PLACE - AND USER HAVN'T YET
    // PROCESSED THE PAYMENT - IT WON'T GO WITH BOOKING
    var calculated = {
        typeName: priceTypeName,
        name: "This amount is refundable",
        amount: _amount
    };
    return calculated;
};
var mapNoneRule = function(priceTypeName, _amount) {
    var calculated = {
        typeName: priceTypeName,
        name: "".concat(priceTypeName),
        amount: _amount
    };
    return calculated;
} //</editor-fold>
;

;// CONCATENATED MODULE: ./src/core/providers/BookingStateProvider.tsx












var initialPriceCalculation = {
    totalPrice: 0,
    dxbTotalPrice: 0,
    grandTotalPrice: 0,
    totalNights: 0,
    pricePerNight: 0
};
var initialBookingInfo = {
    property_id: "-1",
    user_id: "-1",
    // smoobu_id: '-1',
    guests: -1,
    start_date: "",
    end_date: ""
};
var BOOKING_STATE_KEYS = {
    BOOKING_GUESTS_COUNT: "BOOKING_GUESTS_COUNT",
    PRICE_CALCULATIONS: "P_CALC",
    PROPERTY_CALENDAR_PRICES: "P_CAL_CALC",
    SELECTED_DATES: "SELECTED_DATES",
    SELECTED_BOOKING_RANGE: "SELECTED_BOOKING_RANGE",
    DXB_PRICE_CALCULATED_BY_RULES: "DXB_P_CALC_R",
    BOOKING_INFO: "BOOKING_INFO"
};
var ref = (0,_sliced_to_array/* default */.Z)((0,useSafeContext/* default */.Z)(), 2);
var useBookingState = ref[0], Provider = ref[1];
var BookingStateProvider = function(param) {
    var children = param.children;
    var notify = (0,useNotification/* default */.Z)().notify;
    var getUserId = (0,use_user_data/* default */.Z)().getUserId;
    var propertyDetailsData = (0,PropertyStateProvider/* usePropertyState */.Vk)().propertyDetailsData;
    var ref = (0,_sliced_to_array/* default */.Z)((0,graphql/* useCreateBookingPaymentSessionMutation */.Pe)(), 1), createBookingPaymentSessionMutation = ref[0];
    //<editor-fold desc="PRICE CALCULATIONS">
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useLocalStorage/* useLocalStorage */._)(BOOKING_STATE_KEYS.PRICE_CALCULATIONS, initialPriceCalculation, {
        sync: true
    }), 2), priceCalculations = ref1[0], setPriceCalculations = ref1[1];
    //</editor-fold>
    //<editor-fold desc="PROPERTY CALENDAR PRICES">
    var initialPropertyCalendarPrices = {
        dxbstay: null,
        smoobu: null
    };
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,useLocalStorage/* useLocalStorage */._)(BOOKING_STATE_KEYS.PROPERTY_CALENDAR_PRICES, initialPropertyCalendarPrices, {
        sync: true
    }), 2), propertyCalendarPrices = ref2[0], setPropertyCalendarPrices = ref2[1];
    //</editor-fold>
    //<editor-fold desc="BOOKING RANGE SELECTION">
    // FOR STATE
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,useLocalStorage/* useLocalStorage */._)(BOOKING_STATE_KEYS.SELECTED_DATES, [
        null,
        null
    ], {
        sync: true
    }), 2), selectedDates = ref3[0], setSelectedDates = ref3[1];
    // FOR DATA
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,useLocalStorage/* useLocalStorage */._)(BOOKING_STATE_KEYS.SELECTED_BOOKING_RANGE, null, {
        sync: true
    }), 2), selectedBookingRange = ref4[0], setSelectedBookingRange = ref4[1];
    //</editor-fold>
    //<editor-fold desc="GUEST COUNT">
    var ref5 = (0,_sliced_to_array/* default */.Z)((0,useLocalStorage/* useLocalStorage */._)(BOOKING_STATE_KEYS.BOOKING_GUESTS_COUNT, -1, {
        sync: true
    }), 2), guestsCount = ref5[0], setGuestsCount = ref5[1];
    //</editor-fold>
    //<editor-fold desc="SELECTED - PROPERTY - DXB PRICES CALCULATED BY RULES">
    var ref6 = (0,_sliced_to_array/* default */.Z)((0,useLocalStorage/* useLocalStorage */._)(BOOKING_STATE_KEYS.DXB_PRICE_CALCULATED_BY_RULES, [], {
        sync: true
    }), 2), dxbPricesCalculatedByRules = ref6[0], setDxbPricesCalculatedByRules = ref6[1];
    //</editor-fold>
    //<editor-fold desc="BOOKING INFO">
    var ref7 = (0,_sliced_to_array/* default */.Z)((0,useLocalStorage/* useLocalStorage */._)(BOOKING_STATE_KEYS.BOOKING_INFO, initialBookingInfo, {
        sync: true
    }), 2), bookingInfo = ref7[0], setBookingInfo = ref7[1];
    var resetBookingInfo = function() {
        setBookingInfo(null);
        setSelectedDates([
            null,
            null
        ]);
        setGuestsCount(-1);
        setSelectedBookingRange([
            null,
            null
        ]);
        setDxbPricesCalculatedByRules([]);
    };
    //</editor-fold>
    //<editor-fold desc="UTILS">
    var isReadyToBook = function() {
        if (selectedBookingRange && guestsCount) {
            return selectedBookingRange[0] !== null && guestsCount !== -1;
        } else {
            return false;
        }
    };
    //</editor-fold>
    //<editor-fold desc="BOOKING CALLS">
    var createBookingPaymentSession = function() {
        var record = {
            user_id: getUserId().toString(),
            property_id: propertyDetailsData.id.toString(),
            guests: guestsCount || -1,
            // 2022-07-25
            // 25-07-2022
            start_date: (0,date_utils/* getFormattedDate */.L0)(selectedBookingRange[0], "YYYY-MM-DD"),
            end_date: (0,date_utils/* getFormattedDate */.L0)(selectedBookingRange[1], "YYYY-MM-DD")
        };
        setBookingInfo(record);
        // SEND SERVER CALL
        return createBookingPaymentSessionMutation({
            variables: {
                input: record
            }
        }).then(function(result) {
            var ref, ref1, ref2, ref3;
            // console.log('result>> ', result);
            var _status = false;
            if ((result === null || result === void 0 ? void 0 : (ref = result.data) === null || ref === void 0 ? void 0 : ref.createBookingPaymentSession.status) === app_consts/* SUCCESS */.MR) {
                notify(useNotification/* NotificationType.SUCCESS */.k.SUCCESS, "Please wait we are redirecting you to payment page..", 2000);
                _status = true;
            }
            if ((result === null || result === void 0 ? void 0 : (ref1 = result.data) === null || ref1 === void 0 ? void 0 : ref1.createBookingPaymentSession.status) === app_consts/* FAILED */.ig) {
                var ref4;
                // console.log('RESULT FAILED >>', result);
                notify(useNotification/* NotificationType.WARNING */.k.WARNING, "".concat(result === null || result === void 0 ? void 0 : (ref4 = result.data) === null || ref4 === void 0 ? void 0 : ref4.createBookingPaymentSession.data), 2000);
                _status = false;
            }
            if ((result === null || result === void 0 ? void 0 : (ref2 = result.data) === null || ref2 === void 0 ? void 0 : ref2.createBookingPaymentSession.status) === app_consts/* ERROR */.pn) {
                var ref5;
                // console.log('RESULT ERROR >>', result);
                if ((result === null || result === void 0 ? void 0 : (ref5 = result.data) === null || ref5 === void 0 ? void 0 : ref5.createBookingPaymentSession.data) === null) {
                    var ref6;
                    var parsedResp = JSON.parse(result === null || result === void 0 ? void 0 : (ref6 = result.data) === null || ref6 === void 0 ? void 0 : ref6.createBookingPaymentSession.error);
                    var errorMessage = JSON.parse(parsedResp.details.verbose);
                    notify(useNotification/* NotificationType.WARNING */.k.WARNING, "".concat(errorMessage.detail), 2000);
                } else {
                    var ref7;
                    notify(useNotification/* NotificationType.WARNING */.k.WARNING, "".concat(result === null || result === void 0 ? void 0 : (ref7 = result.data) === null || ref7 === void 0 ? void 0 : ref7.createBookingPaymentSession.data), 2000);
                }
                _status = false;
            }
            return Promise.resolve({
                url: result === null || result === void 0 ? void 0 : (ref3 = result.data) === null || ref3 === void 0 ? void 0 : ref3.createBookingPaymentSession.data,
                status: _status
            });
        }).catch(function(err) {
            console.error(err);
            notify(useNotification/* NotificationType.ERROR */.k.ERROR, "Oops we broke something!", 2000);
            return Promise.resolve({
                url: "",
                status: false
            });
        });
    };
    //</editor-fold>
    //<editor-fold desc="GUEST COUNTER INTERNALS">
    var getGuestLimit = function() {
        var ref;
        var arr = Array((ref = propertyDetailsData.details) === null || ref === void 0 ? void 0 : ref.max_occupancy).fill(0).map(function(_, ind) {
            return {
                count: ind + 1
            };
        });
        return arr;
    };
    //</editor-fold>
    //<editor-fold desc="PRICE CALCULATIONS RELATED">
    var executeDXBPricingRules = function(totalNights, range) {
        var data = propertyCalendarPrices.dxbstay;
        var result = [];
        data === null || data === void 0 ? void 0 : data.forEach(function(priceItem) {
            var isConditional = priceItem.priceType.conditional;
            if (isConditional) {
                var condition = priceItem.priceType.condition.split("|")[0];
                var conditionValue = priceItem.priceType.condition.split("|")[1];
                // const conditionSubValue = priceItem.priceType.condition.split('|')[2];
                if (condition === "LIMIT") {
                    var calculated = mapLimitRule(totalNights, conditionValue, priceItem.priceType.name, priceItem.amount, propertyDetailsData.details.bed_rooms);
                    result.push(calculated);
                }
                if (condition === "EVERY") {
                    var calculated1 = mapEveryRule(range, conditionValue, priceItem.priceType.name, priceItem.amount);
                    result.push(calculated1);
                }
                if (condition === "UNTIL") {
                    var calculated2 = mapUntilRule(priceItem.priceType.name, priceItem.amount);
                    result.push(calculated2);
                }
            } else {
                var conditionTitle = priceItem.priceType.condition;
                if (conditionTitle === "NONE") {
                    var calculated3 = mapNoneRule(priceItem.priceType.name, priceItem.amount);
                    result.push(calculated3);
                }
            }
        });
        return result;
    };
    var calculatePricesAndStore = function(dateRange) {
        var data = propertyCalendarPrices;
        // console.log(dateRange, 'dateRange')
        // console.log(data, 'data')
        if (dateRange && data) {
            //RUN CALCULATIONS ON EACH TIME RANGE SELECTION IS DONE
            var datesInRang = (0,date_utils/* getDatesInRange */.pC)(dateRange);
            var calendarData = (0,date_utils/* extractDatesDataFromCalendarData */.dq)(datesInRang, data.smoobu);
            // REDUCING 1 DAY
            calendarData.pop();
            // IF THERE IS CALENDAR DATA DO STUFF
            if (calendarData.length) {
                var _totalNights = (0,dxb_utils/* getTotalNights */.MA)(calendarData);
                var _smoobuTotalPrice = (0,dxb_utils/* getTotalPrice */.m_)(calendarData);
                var _pricePerNight = (0,dxb_utils/* getPricePerNight */.Y3)(_totalNights, _smoobuTotalPrice);
                // TOTAL CALCULATIONS
                var dxbRuleCalculatedTotal = executeDXBPricingRules(_totalNights, dateRange);
                // const _dxbTotalPrice = getDxbTotal(data.dxbstay);
                // const _dxbTotalPrice = getDxbTotal(dxbRuleCalculatedTotal);
                // const _grandTotal = getGrandTotal(_smoobuTotalPrice, _dxbTotalPrice)
                var _dxbTotalPrice = dxbRuleCalculatedTotal.reduce(function(acc, item) {
                    return acc + item.amount;
                }, 0);
                var _grandTotal = _smoobuTotalPrice + _dxbTotalPrice;
                // console.log(datesInRang, "datesInRang")
                // console.log(calendarData, "calendarData")
                // console.log(_totalNights, "totalNights")
                // console.log(_smoobuTotalPrice, "smoobuTotalPrice")
                // console.log(_pricePerNight, "pricePerNight")
                // console.log(_dxbTotalPrice, 'dxbTotalPrice')
                // console.log(_grandTotal, "grandTotal")
                setDxbPricesCalculatedByRules(dxbRuleCalculatedTotal);
                setPriceCalculations({
                    dxbTotalPrice: _dxbTotalPrice,
                    grandTotalPrice: _grandTotal,
                    pricePerNight: _pricePerNight,
                    totalNights: _totalNights,
                    totalPrice: _smoobuTotalPrice
                });
            }
        }
    };
    var resetPrices = function() {
        setPriceCalculations({
            dxbTotalPrice: 0,
            grandTotalPrice: 0,
            pricePerNight: 0,
            totalNights: 0,
            totalPrice: 0
        });
        setDxbPricesCalculatedByRules([]);
        setSelectedBookingRange([
            null,
            null
        ]);
    };
    //</editor-fold>
    var providerValues = {
        priceCalculations: priceCalculations,
        setPriceCalculations: setPriceCalculations,
        propertyCalendarPrices: propertyCalendarPrices,
        setPropertyCalendarPrices: setPropertyCalendarPrices,
        selectedDates: selectedDates,
        setSelectedDates: setSelectedDates,
        selectedBookingRange: selectedBookingRange,
        setSelectedBookingRange: setSelectedBookingRange,
        guestsCount: guestsCount,
        setGuestsCount: setGuestsCount,
        dxbPricesCalculatedByRules: dxbPricesCalculatedByRules,
        setDxbPricesCalculatedByRules: setDxbPricesCalculatedByRules,
        bookingInfo: bookingInfo,
        resetBookingInfo: resetBookingInfo,
        isReadyToBook: isReadyToBook,
        createBookingPaymentSession: createBookingPaymentSession,
        getGuestLimit: getGuestLimit,
        calculatePricesAndStore: calculatePricesAndStore,
        resetPrices: resetPrices
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Provider, {
        value: providerValues,
        children: children
    });
};


/***/ }),

/***/ 86727:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Vk": function() { return /* binding */ usePropertyState; },
/* harmony export */   "dl": function() { return /* binding */ PropertyStateProvider; }
/* harmony export */ });
/* unused harmony exports PROPERTY_STATE_KEYS, Provider */
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(828);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _hooks_useSafeContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71087);
/* harmony import */ var _hooks_useLocalStorage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71992);




var PROPERTY_STATE_KEYS = {
    propertyDetailsData: "PROPERTY_DETAILS_DATA",
    selectedImageIndex: "SELECTED_IMAGE_INDEX",
    imageSrc: "IMAGE_SRC"
};
var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_hooks_useSafeContext__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(), 2);
var usePropertyState = ref[0], Provider = ref[1];
var PropertyStateProvider = function(param) {
    var children = param.children;
    var findImageIndex = function findImageIndex(_alt) {
        var index = getAllGalleryImages().findIndex(function(img) {
            return img.alt === _alt;
        });
        if (selectedImageIndex) {
            setSelectedImageIndex(JSON.stringify(index));
        } else {
            setSelectedImageIndex(JSON.stringify(0));
        }
    };
    /*const [imageSrc, setImageSrc] =
        useLocalStorage(STATE_KEYS.imageSrc, null, { sync: true });*/ var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_hooks_useLocalStorage__WEBPACK_IMPORTED_MODULE_2__/* .useLocalStorage */ ._)(PROPERTY_STATE_KEYS.selectedImageIndex, "0", {
        sync: true
    }), 2), selectedImageIndex = ref[0], setSelectedImageIndex = ref[1];
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_hooks_useLocalStorage__WEBPACK_IMPORTED_MODULE_2__/* .useLocalStorage */ ._)(PROPERTY_STATE_KEYS.propertyDetailsData, "", {
        sync: true
    }), 2), propertyDetailsData = ref1[0], setPropertyDetailsData = ref1[1];
    var resetPropertyDetailsData = function() {
        return setPropertyDetailsData(null);
    };
    var getGalleryImages = function() {};
    var getAllGalleryImages = function() {
        var ref;
        return propertyDetailsData ? (ref = JSON.parse(propertyDetailsData).images) === null || ref === void 0 ? void 0 : ref.filter(function(img) {
            return img.type === "image" && img;
        }) : [];
    };
    var getGalleryFrontImages = function() {
        var frontPositionImages = getAllGalleryImages().filter(function(img) {
            return img.position !== -1;
        });
        var frontImages = [];
        // RE INDEXING ACCORDING TO POSITION
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for(var i = 0; i < frontPositionImages.length; i++){
            frontImages[frontPositionImages[i].position] = frontPositionImages[i];
        }
        return frontImages;
    };
    var providerValues = {
        propertyDetailsData: propertyDetailsData ? JSON.parse(propertyDetailsData) : null,
        setPropertyDetailsData: setPropertyDetailsData,
        resetPropertyDetailsData: resetPropertyDetailsData,
        getAllGalleryImages: getAllGalleryImages,
        getGalleryFrontImages: getGalleryFrontImages,
        findImageIndex: findImageIndex,
        selectedImageIndex: JSON.parse(selectedImageIndex)
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Provider, {
        value: providerValues,
        children: children
    });
};


/***/ }),

/***/ 84396:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$w": function() { return /* binding */ AppRoutes; },
/* harmony export */   "Hv": function() { return /* binding */ AppMenuLinks; },
/* harmony export */   "dj": function() { return /* binding */ RESTRICTED_PATHS; },
/* harmony export */   "tz": function() { return /* binding */ AUTH_PATHS; },
/* harmony export */   "ul": function() { return /* binding */ getPageRoute; }
/* harmony export */ });
/* unused harmony exports getPageSlug, getSlugRoute */
/* harmony import */ var slugify__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31304);
/* harmony import */ var slugify__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(slugify__WEBPACK_IMPORTED_MODULE_0__);

var AppRoutes = {
    NOT_FOUND: "/not-found",
    HOME: "/",
    CONTACT: "/contact-us",
    ACCOUNT: "/account",
    FAVORITES: "/favorites",
    ABOUT: "/about-us",
    BOOK: "/book",
    BOOKINGS: "/bookings",
    CHANGE_PASSWORD: "/reset-password",
    FORGET_PASSWORD: "/forget-password",
    PROPERTIES: "/properties",
    SEARCH: "/search",
    REGISTER: "/register",
    LOGIN: "/login",
    TERMS: "/terms",
    POLICIES: "/policies",
    PROPERTY_DETAILS: "/property-details",
    RESPONSE: "/response"
};
var AppMenuLinks = [
    {
        link: AppRoutes.PROPERTIES,
        label: "Properties"
    }, 
];
var RESTRICTED_PATHS = [
    "/account"
];
var AUTH_PATHS = [
    AppRoutes.LOGIN,
    AppRoutes.REGISTER,
    AppRoutes.CHANGE_PASSWORD,
    AppRoutes.FORGET_PASSWORD, 
];
var getPageRoute = function(currentLocation, id) {
    return "".concat(currentLocation, "/").concat(id);
};
var getPageSlug = function(title, location) {
    // return `${location?.city}/${location?.address}/${title}`
    return slugify("".concat(title), {
        lower: true
    });
};
var getSlugRoute = function(route, slug, location) {
    // return getPageRoute(route, getPageSlug(slug))
    return getPageSlug(slug);
};


/***/ }),

/***/ 63002:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "WJ": function() { return /* binding */ convertStrToSnakeCase; },
/* harmony export */   "jj": function() { return /* binding */ uniq; }
/* harmony export */ });
/* unused harmony exports toCapitalize, validateEmail, removeFromLast, isFunction, isPathActive, isDefined, isString, isRegex, isDateObject, isObject, isTruthy, noop, getMultipleRandom */
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);





var convertStrToSnakeCase = function(str) {
    return str === null || str === void 0 ? void 0 : str.match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g).map(function(s) {
        return s.toLowerCase();
    }).join("-");
};
var toCapitalize = function(name) {
    var _name = _to_array(name), first = _name[0], rest = _name.slice(1);
    return "".concat(first.toUpperCase()).concat(rest.join(""));
};
var validateEmail = function(value) {
    return /^\w+([\\.-]?\w+)*@\w+([\\.-]?\w+)*(\.\w{2,3})+$/.test(value);
};
function removeFromLast(path, key) {
    var i = path.lastIndexOf(key);
    return i === -1 ? path : path.substring(0, i);
}
function isFunction(fn) {
    return typeof fn === "function";
}
var isPathActive = function(href) {
    var exact = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    if (!isBrowser) return false;
    if (exact) return Router.pathname === href;
    return Router.pathname.startsWith(href);
};
var isDefined = function(t) {
    return t != null;
};
var isString = function(value) {
    return typeof value === "string";
};
var isRegex = function(value) {
    return _instanceof(value, RegExp);
};
var isDateObject = function(value) {
    return _instanceof(value, Date);
};
var isObject = function(value) {
    return Boolean(value) && !Array.isArray(value) && typeof value === "object" && !isRegex(value) && !isDateObject(value);
};
/**
 * Converts a string or number to a boolean.
 *
 * @example
 *      isTruthy("FALSE");
 *      // false
 *
 *      isTruthy("off");
 *      // false
 *
 *      isTruthy(0);
 *      // false
 *
 *      isTruthy(undefined);
 *      // false
 *
 * ts-prune-ignore-next
 */ var isTruthy = function(value) {
    var normalized = typeof value === "string" ? value.toLowerCase() : value;
    return !(normalized == null || normalized <= 0 || normalized === "false" || normalized === "off");
};
var noop = Function.prototype;
var uniq = function(array) {
    return Array.from(new Set(array));
};
function getMultipleRandom(arr, num) {
    var shuffled = _to_consumable_array(arr).sort(function() {
        return 0.5 - Math.random();
    });
    return shuffled.slice(0, num);
}


/***/ }),

/***/ 54938:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EX": function() { return /* binding */ formatSearchBarDateLabel; },
/* harmony export */   "L0": function() { return /* binding */ getFormattedDate; },
/* harmony export */   "M4": function() { return /* binding */ formatBookingCardRangeDate; },
/* harmony export */   "Ud": function() { return /* binding */ disablePastAndControlledDates; },
/* harmony export */   "dq": function() { return /* binding */ extractDatesDataFromCalendarData; },
/* harmony export */   "gS": function() { return /* binding */ getWeeklyDates; },
/* harmony export */   "p6": function() { return /* binding */ formatDate; },
/* harmony export */   "pC": function() { return /* binding */ getDatesInRange; },
/* harmony export */   "po": function() { return /* binding */ matchDates; },
/* harmony export */   "rJ": function() { return /* binding */ disablePastDates; },
/* harmony export */   "sx": function() { return /* binding */ getBlockedDatesFromCalendar; },
/* harmony export */   "vF": function() { return /* binding */ formatSearchDate; }
/* harmony export */ });
/* unused harmony exports getYearMonthsFromCurrentMonth, getFormattedMonthName, getRangeDate, checkIfRangeIsSelected */
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27484);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var dayjs_plugin_toObject__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25757);
/* harmony import */ var dayjs_plugin_toObject__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(dayjs_plugin_toObject__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_index__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47048);




dayjs__WEBPACK_IMPORTED_MODULE_0___default().extend((dayjs_plugin_toObject__WEBPACK_IMPORTED_MODULE_1___default()));
var getWeeklyDates = function(startDate, endDate) {
    var dateArray = [];
    var currentDate = dayjs__WEBPACK_IMPORTED_MODULE_0___default()(startDate);
    var stopDate = dayjs__WEBPACK_IMPORTED_MODULE_0___default()(endDate);
    while(currentDate <= stopDate){
        dateArray.push(dayjs__WEBPACK_IMPORTED_MODULE_0___default()(currentDate).format("YYYY-MM-DD"));
        currentDate = dayjs__WEBPACK_IMPORTED_MODULE_0___default()(currentDate).add(1, "weeks");
    }
    // console.log(dateArray, 'dateArray')
    return dateArray;
};
var MonthNames = (/* unused pure expression or super */ null && ([
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
]));
var defaultFormat = "DD-MM-YYYY";
var getYearMonthsFromCurrentMonth = function() {
    var datesArr = [];
    for(var i = 0; i < 12; i++){
        var currentMonth = {
            id: i.toString(),
            monthName: MonthNames[dayjs().add(i, "month").month()],
            year: dayjs().add(i, "month").year(),
            dateObj: dayjs().add(i, "month").format(defaultFormat).toString()
        };
        datesArr.push(currentMonth);
    }
    return datesArr;
};
var getFormattedMonthName = function(months, template) {
    var montNamesArr = [];
    months === null || months === void 0 ? void 0 : months.forEach(function(month) {
        var format = dayjs(month === null || month === void 0 ? void 0 : month.dateObj, defaultFormat).format(template).toString();
        montNamesArr.push(format);
    });
    return montNamesArr.toString();
};
var getBlockedDatesFromCalendar = function(calendarData) {
    // console.log(calendarData?.length, "calendarData")
    var blockedDates = [];
    calendarData === null || calendarData === void 0 ? void 0 : calendarData.forEach(function(item) {
        // console.log(item?.blocked, "item?.blocked")
        if ((item === null || item === void 0 ? void 0 : item.blocked) === true || (item === null || item === void 0 ? void 0 : item.available) === false) {
            blockedDates.push(item === null || item === void 0 ? void 0 : item.date);
        }
    });
    return blockedDates;
};
var disablePastDates = function(current) {
    return dayjs__WEBPACK_IMPORTED_MODULE_0___default()().add(-1, "days") >= current;
};
var disablePastAndControlledDates = function(current, disabledDates) {
    // const datesToDisable = ["2022-06-20", "2022-06-22", '2022-06-24'];
    return disablePastDates(current) || disabledDates.find(function(date) {
        return date === dayjs__WEBPACK_IMPORTED_MODULE_0___default()(current).format("YYYY-MM-DD");
    });
};
var matchDates = function(dateString, dates) {
    // THIS EXPECTS START AND END DATES
    //CONTEXT IS THAT - IF THE DATE IS MATCHED DON'T ADD
    // console.log(JSON.stringify(dateString, null, 2), "dateString")
    // console.log(JSON.stringify(dates, null, 2), "dates")
    // console.log("empty",empty(dateString[0]), empty(dateString[1]) )
    // console.log("MATCHES", intersection(dateString, dates)?.length !== 0)
    if (!(0,_utils_index__WEBPACK_IMPORTED_MODULE_3__/* .empty */ .cS)(dateString[0]) && !(0,_utils_index__WEBPACK_IMPORTED_MODULE_3__/* .empty */ .cS)(dateString[1])) {
        var ref;
        return ((ref = (0,lodash__WEBPACK_IMPORTED_MODULE_2__.intersection)(dateString, dates)) === null || ref === void 0 ? void 0 : ref.length) !== 0;
    } else {
        return true;
    }
};
var formatSearchDate = function(date, placeHolder) {
    if (date !== null) {
        return dayjs__WEBPACK_IMPORTED_MODULE_0___default()(date, "DD/MM/YYYY").format("YYYY-MM-DD").toString();
    } else {
        return placeHolder;
    }
};
var formatBookingCardRangeDate = function(date, placeHolder) {
    if (date !== null) {
        return dayjs__WEBPACK_IMPORTED_MODULE_0___default()(date, "YYYY-MM-DD").format("DD-MM-YYYY").toString();
    } else {
        return placeHolder;
    }
};
var formatSearchBarDateLabel = function(date, placeHolder) {
    if (date !== null) {
        return dayjs__WEBPACK_IMPORTED_MODULE_0___default()(date, "DD/MM/YYYY").format("DD-MM-YYYY").toString();
    } else {
        return placeHolder;
    }
};
var getDatesInRange = function(range) {
    if (range) {
        var startDate = range[0];
        var endDate = range[1];
        var dateArray = [];
        var currentDate = dayjs__WEBPACK_IMPORTED_MODULE_0___default()(startDate);
        var stopDate = dayjs__WEBPACK_IMPORTED_MODULE_0___default()(endDate);
        while(currentDate <= stopDate){
            dateArray.push(dayjs__WEBPACK_IMPORTED_MODULE_0___default()(currentDate).format("YYYY-MM-DD"));
            currentDate = dayjs__WEBPACK_IMPORTED_MODULE_0___default()(currentDate).add(1, "days");
        }
        return dateArray;
    } else {
        return [];
    }
};
var extractDatesDataFromCalendarData = function(rangeDates, calendarData) {
    // console.log(calendarData, "extractDatesDataFromCalendarData")
    // console.log(intersection(rangeDates, calendarData), "extractDatesDataFromCalendar")
    var selectedDates = [];
    calendarData === null || calendarData === void 0 ? void 0 : calendarData.forEach(function(calendarDate) {
        var localDate = rangeDates.find(function(local) {
            return local === (calendarDate === null || calendarDate === void 0 ? void 0 : calendarDate.date);
        });
        if (localDate !== undefined) {
            selectedDates.push(calendarDate);
        }
    });
    // console.log(selectedDates, "selectedDates")
    return selectedDates;
};
var getRangeDate = function(dateString) {
    if (!empty(dateString[0]) && !empty(dateString[1])) {
        return [
            dayjs(dateString[0]),
            dayjs(dateString[1])
        ];
    } else {
        return [
            null,
            null
        ];
    }
};
/**
 * 'YYYY-MM-DD'
 * */ var getFormattedDate = function(dateString, format) {
    return dayjs__WEBPACK_IMPORTED_MODULE_0___default()(dateString).format(format).toString();
};
var checkIfRangeIsSelected = function(dateString) {
    return !empty(dateString[0]) && !empty(dateString[1]);
};
var formatDate = function(date) {
    return dayjs__WEBPACK_IMPORTED_MODULE_0___default()(date, "YYYY-MM-DD").format("DD-MM-YYYY").toString();
};


/***/ }),

/***/ 10646:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D3": function() { return /* binding */ getTheKeywords; },
/* harmony export */   "E5": function() { return /* binding */ extractTags; },
/* harmony export */   "MA": function() { return /* binding */ getTotalNights; },
/* harmony export */   "NQ": function() { return /* binding */ formatGuestsCount; },
/* harmony export */   "QL": function() { return /* binding */ mapFavParamToProps; },
/* harmony export */   "T5": function() { return /* binding */ filterCheckPropertiesByIds; },
/* harmony export */   "Ud": function() { return /* binding */ mapLocationStreetLabelText; },
/* harmony export */   "Ui": function() { return /* binding */ formatTitle; },
/* harmony export */   "Y3": function() { return /* binding */ getPricePerNight; },
/* harmony export */   "Zv": function() { return /* binding */ extractKeywords; },
/* harmony export */   "ac": function() { return /* binding */ filterPropertiesByIds; },
/* harmony export */   "dr": function() { return /* binding */ mapLocationDescLabelText; },
/* harmony export */   "jw": function() { return /* binding */ getPropertiesByKeyword; },
/* harmony export */   "m_": function() { return /* binding */ getTotalPrice; },
/* harmony export */   "nA": function() { return /* binding */ formatTitleNoS; },
/* harmony export */   "ol": function() { return /* binding */ getAddressText; },
/* harmony export */   "z0": function() { return /* binding */ displayAvatarName; }
/* harmony export */ });
/* unused harmony exports splitName, showTotal, genRandomKey, capitalizeFirstLetter, extractLocations, extractLocationAddresses, getPropertiesByLocation, filterUserProperties, extractKeywordsFromSingleLocation */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29815);
/* harmony import */ var _utils_data_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(63002);
/* harmony import */ var _utils_index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47048);






var mapLocationDescLabelText = function(_address) {
    if ((0,_utils_index__WEBPACK_IMPORTED_MODULE_1__/* .empty */ .cS)(_address)) return;
    var arrText = _address.split("||");
    if (arrText.length > 1) {
        return arrText[1].trimEnd();
    } else {
        return _address;
    }
};
var mapLocationStreetLabelText = function(_address) {
    if ((0,_utils_index__WEBPACK_IMPORTED_MODULE_1__/* .empty */ .cS)(_address)) return;
    var arrText = _address.split("||");
    if (arrText.length > 1) {
        return arrText[0].trimEnd();
    } else {
        return _address;
    }
};
var splitName = function() {
    var name = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    var ref = _to_array(name.split(" ").filter(Boolean)), firstName = ref[0], lastName = ref.slice(1);
    return {
        firstName: firstName,
        lastName: lastName.join(" ")
    };
};
var displayAvatarName = function(name) {
    if (name === null || name === undefined) return;
    var hasTokens = name.indexOf(" ") !== -1;
    // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
    var check = name.substring(0, hasTokens ? 1 : 2) + (hasTokens ? name.charAt(name.lastIndexOf(" ") + 1) : "");
    return check.toUpperCase();
/*const nameParts = splitName(name);

    if (nameParts.lastName === '') {
        return name.toUpperCase();
    } else {
        return `${nameParts.firstName[0]}${nameParts.lastName[0]}`.toUpperCase();
    }*/ };
var showTotal = function(total) {
    return "".concat(total > 1 ? "".concat(total, " Records") : "".concat(total, " Record"));
};
var genRandomKey = function() {
    var radix = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 36, length = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 7;
    return Math.random().toString(radix).substring(length);
//return Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 5);
};
var getAddressText = function(location) {
    return "".concat(mapLocationStreetLabelText(location === null || location === void 0 ? void 0 : location.address), " \\ ").concat(location === null || location === void 0 ? void 0 : location.city, " \\ ").concat(location === null || location === void 0 ? void 0 : location.country);
};
var getTotalNights = function(calendarData) {
    // YEAH KOE MAZAAQ HORAHA HAY HAN :D :D
    return calendarData === null || calendarData === void 0 ? void 0 : calendarData.length;
};
var getPricePerNight = function(totalNights, totalPrice) {
    return Number(totalPrice) / Number(totalNights);
};
var getTotalPrice = function(calendarData) {
    var total = calendarData.reduce(function(acc, date) {
        return acc + date.price;
    }, 0);
    // console.log(total, "total")
    return total;
};
function capitalizeFirstLetter(string) {
    return string[0].toUpperCase() + string.slice(1);
}
function extractLocations(properties) {
    var locations = properties === null || properties === void 0 ? void 0 : properties.map(function(property) {
        return _object_spread({
            propertyId: property.id
        }, property.location);
    }).flat();
    return locations;
}
function extractLocationAddresses(locations) {
    var addresses = [];
    locations === null || locations === void 0 ? void 0 : locations.forEach(function(location) {
        addresses.push(location.address);
    });
    return addresses;
}
function getPropertiesByLocation(location, properties) {
    // console.log(location, "<>")
    var filtered = properties === null || properties === void 0 ? void 0 : properties.filter(function(property) {
        var ref;
        if ((property === null || property === void 0 ? void 0 : (ref = property.location) === null || ref === void 0 ? void 0 : ref.address) === location) {
            return property;
        } else if (location === "All") {
            return properties;
        }
    });
    return filtered;
}
function getPropertiesByKeyword(keyword, properties) {
    // console.log(keyword, "<>")
    var filtered = properties === null || properties === void 0 ? void 0 : properties.filter(function(property) {
        if (property === null || property === void 0 ? void 0 : property.location.keywords.includes(keyword)) {
            return property;
        } else if (keyword === "All") {
            return properties;
        }
    });
    return filtered;
}
function filterCheckPropertiesByIds(propertyID, userProps) {
    // console.log(propertyID, "<propertyID>")
    // console.log(userProps, "<userProps>")
    var filtered = userProps === null || userProps === void 0 ? void 0 : userProps.filter(function(property) {
        return (property === null || property === void 0 ? void 0 : property.property_id) === propertyID;
    });
    // console.log(filtered, "filtered")
    return (filtered === null || filtered === void 0 ? void 0 : filtered.length) > 0;
}
function filterPropertiesByIds(propertyID, userProps) {
    // console.log(propertyID, "<propertyID>")
    // console.log(userProps, "<userProps>")
    var filtered = userProps === null || userProps === void 0 ? void 0 : userProps.filter(function(property) {
        return (property === null || property === void 0 ? void 0 : property.property_id) !== propertyID;
    });
    // console.log(filtered, "filtered")
    return filtered;
}
function filterUserProperties(allProps, userProps) {
    var filtered = [];
    allProps === null || allProps === void 0 ? void 0 : allProps.forEach(function(prop) {
        userProps === null || userProps === void 0 ? void 0 : userProps.forEach(function(uP) {
            // console.log(uP?.id, "USER PROP")
            // console.log(prop?.id, "PROP")
            // console.log(prop?.id === uP?.id, "===")
            if ((prop === null || prop === void 0 ? void 0 : prop.id) === (uP === null || uP === void 0 ? void 0 : uP.id)) {
                filtered.push(prop);
            }
        });
    });
    // console.log(filtered, "FILTERED")
    return (filtered === null || filtered === void 0 ? void 0 : filtered.length) > 0 ? filtered : [];
}
var extractKeywords = function(searchLocations) {
    var arrKeywords = [];
    searchLocations === null || searchLocations === void 0 ? void 0 : searchLocations.forEach(function(location) {
        var _arrKeywords;
        (_arrKeywords = arrKeywords).push.apply(_arrKeywords, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(location.keywords.split(",")));
    });
    var cleanKeywords = arrKeywords.map(function(keyword) {
        return keyword.trim();
    }).flat();
    // return [...new Set(cleanKeywords)];
    return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_utils_data_utils__WEBPACK_IMPORTED_MODULE_0__/* .uniq */ .jj)(cleanKeywords));
};
var extractKeywordsFromSingleLocation = function(location) {
    var _arrKeywords;
    var arrKeywords = [];
    arrKeywords === null || arrKeywords === void 0 ? void 0 : (_arrKeywords = arrKeywords).push.apply(_arrKeywords, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(location.keywords.split(",")));
    var cleanKeywords = arrKeywords.map(function(keyword) {
        return keyword.trim();
    }).flat();
    // return [...new Set(cleanKeywords)];
    return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_utils_data_utils__WEBPACK_IMPORTED_MODULE_0__/* .uniq */ .jj)(cleanKeywords));
};
/*export function formatTitle(value: number, label: string) {
    return value === 1 ? `${value} ${label}` : `${value} ${label}s`
}*/ function formatTitle(value, label) {
    return value === 1 ? "".concat(label) : "".concat(label, "s");
}
function formatTitleNoS(value, label) {
    return value >= 1 ? "".concat(label) : "".concat(label);
}
var formatGuestsCount = function(count, placeHolder) {
    if (count !== 0) {
        return count > 1 ? "".concat(count, " Guests") : "".concat(count, " Guest");
    } else {
        return placeHolder;
    }
};
function mapFavParamToProps(userPropIds, data) {
    return data.map(function(property) {
        var _isFavProp = filterCheckPropertiesByIds(property.id, userPropIds);
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, property), {
            isFavProp: _isFavProp
        });
    });
}
var getTheKeywords = function(listData) {
    var allKeyWords = [];
    var defaultFilters = [
        "All"
    ];
    if (listData !== null) {
        var // ADDING DEFAULTS
        _orderedLocations;
        listData === null || listData === void 0 ? void 0 : listData.forEach(function(prop) {
            if (prop.location.keywords !== undefined) {
                var _allKeyWords;
                (_allKeyWords = allKeyWords).push.apply(_allKeyWords, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(extractKeywordsFromSingleLocation(prop.location)));
            }
        });
        var orderedLocations = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_utils_data_utils__WEBPACK_IMPORTED_MODULE_0__/* .uniq */ .jj)(allKeyWords));
        (_orderedLocations = orderedLocations).splice.apply(_orderedLocations, [
            0,
            0
        ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(defaultFilters)));
        orderedLocations === null || orderedLocations === void 0 ? void 0 : orderedLocations.map(function(keyword) {
            return {
                label: keyword,
                value: keyword
            };
        });
        // console.log(orderedLocations, 'orderedLocations')
        return orderedLocations;
    } else {
        return null;
    }
};
var extractTags = function(k, g, sd, ed) {
    /***
     * CODES
     * EN
     *
     * EA
     *
     * EK
     * EG
     * ER
     *
     * EK_EG
     * EK_ER
     * EG_ER
     *
     * */ // console.log(k, g, sd, ed, '')
    var code = "EN";
    if (!(0,_utils_index__WEBPACK_IMPORTED_MODULE_1__/* .empty */ .cS)(k) && !(0,_utils_index__WEBPACK_IMPORTED_MODULE_1__/* .empty */ .cS)(sd) && !(0,_utils_index__WEBPACK_IMPORTED_MODULE_1__/* .empty */ .cS)(ed) && g !== 0) {
        code = "EA";
    } else if (!(0,_utils_index__WEBPACK_IMPORTED_MODULE_1__/* .empty */ .cS)(k) && g !== 0) {
        code = "EK_EG";
    } else if (!(0,_utils_index__WEBPACK_IMPORTED_MODULE_1__/* .empty */ .cS)(k) && !(0,_utils_index__WEBPACK_IMPORTED_MODULE_1__/* .empty */ .cS)(sd) && !(0,_utils_index__WEBPACK_IMPORTED_MODULE_1__/* .empty */ .cS)(ed)) {
        code = "EK_ER";
    } else if (!(0,_utils_index__WEBPACK_IMPORTED_MODULE_1__/* .empty */ .cS)(sd) && !(0,_utils_index__WEBPACK_IMPORTED_MODULE_1__/* .empty */ .cS)(ed) && g !== 0) {
        code = "EG_ER";
    } else {
        if (!(0,_utils_index__WEBPACK_IMPORTED_MODULE_1__/* .empty */ .cS)(k)) {
            code = "EK";
        }
        if (g !== 0) {
            code = "EG";
        }
        if (!(0,_utils_index__WEBPACK_IMPORTED_MODULE_1__/* .empty */ .cS)(sd) && !(0,_utils_index__WEBPACK_IMPORTED_MODULE_1__/* .empty */ .cS)(ed)) {
            code = "ER";
        }
    }
    return code;
};


/***/ }),

/***/ 41448:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "HI": function() { return /* binding */ generateKey; },
/* harmony export */   "Ox": function() { return /* binding */ generateId; },
/* harmony export */   "TD": function() { return /* binding */ decodeToken; },
/* harmony export */   "Vc": function() { return /* binding */ BLUR_DATA; },
/* harmony export */   "g5": function() { return /* binding */ S3_SITE_MEDIA_BUCKET_URL; },
/* harmony export */   "gK": function() { return /* binding */ S3_USER_BUCKET_URL; },
/* harmony export */   "h1": function() { return /* binding */ returnFileSize; },
/* harmony export */   "oe": function() { return /* binding */ S3_PROPERTY_BUCKET_URL; },
/* harmony export */   "tT": function() { return /* binding */ bytesToMb; },
/* harmony export */   "ul": function() { return /* binding */ MAX_FILE_SIZE_BYTES; }
/* harmony export */ });
/* unused harmony exports allowMimeTypes, isImage, checkFileSizeIsInLimit, checkFileIsAImage */
/* harmony import */ var jwt_decode__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96245);


// export const DXBSTAY_LOGO_BLUR_DATA = 'data:image/jpeg;base64,/9j/4QAYRXhpZgAASUkqAAgAAAAAAAAAAAAAAP/sABFEdWNreQABAAQAAABkAAD/4QMvaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wLwA8P3hwYWNrZXQgYmVnaW49Iu+7vyIgaWQ9Ilc1TTBNcENlaGlIenJlU3pOVGN6a2M5ZCI/PiA8eDp4bXBtZXRhIHhtbG5zOng9ImFkb2JlOm5zOm1ldGEvIiB4OnhtcHRrPSJBZG9iZSBYTVAgQ29yZSA5LjAtYzAwMCA3OS4xNzFjMjdmYWIsIDIwMjIvMDgvMTYtMjI6MzU6NDEgICAgICAgICI+IDxyZGY6UkRGIHhtbG5zOnJkZj0iaHR0cDovL3d3dy53My5vcmcvMTk5OS8wMi8yMi1yZGYtc3ludGF4LW5zIyI+IDxyZGY6RGVzY3JpcHRpb24gcmRmOmFib3V0PSIiIHhtbG5zOnhtcD0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wLyIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bXA6Q3JlYXRvclRvb2w9IkFkb2JlIFBob3Rvc2hvcCAyNC4wIChXaW5kb3dzKSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDozOUE3NjcxMzk4MEMxMUVEOEY4OERBNTFFNzhGODg4QSIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDozOUE3NjcxNDk4MEMxMUVEOEY4OERBNTFFNzhGODg4QSI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjM5QTc2NzExOTgwQzExRUQ4Rjg4REE1MUU3OEY4ODhBIiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOjM5QTc2NzEyOTgwQzExRUQ4Rjg4REE1MUU3OEY4ODhBIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+/+IMWElDQ19QUk9GSUxFAAEBAAAMSExpbm8CEAAAbW50clJHQiBYWVogB84AAgAJAAYAMQAAYWNzcE1TRlQAAAAASUVDIHNSR0IAAAAAAAAAAAAAAAAAAPbWAAEAAAAA0y1IUCAgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAARY3BydAAAAVAAAAAzZGVzYwAAAYQAAABsd3RwdAAAAfAAAAAUYmtwdAAAAgQAAAAUclhZWgAAAhgAAAAUZ1hZWgAAAiwAAAAUYlhZWgAAAkAAAAAUZG1uZAAAAlQAAABwZG1kZAAAAsQAAACIdnVlZAAAA0wAAACGdmlldwAAA9QAAAAkbHVtaQAAA/gAAAAUbWVhcwAABAwAAAAkdGVjaAAABDAAAAAMclRSQwAABDwAAAgMZ1RSQwAABDwAAAgMYlRSQwAABDwAAAgMdGV4dAAAAABDb3B5cmlnaHQgKGMpIDE5OTggSGV3bGV0dC1QYWNrYXJkIENvbXBhbnkAAGRlc2MAAAAAAAAAEnNSR0IgSUVDNjE5NjYtMi4xAAAAAAAAAAAAAAASc1JHQiBJRUM2MTk2Ni0yLjEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFhZWiAAAAAAAADzUQABAAAAARbMWFlaIAAAAAAAAAAAAAAAAAAAAABYWVogAAAAAAAAb6IAADj1AAADkFhZWiAAAAAAAABimQAAt4UAABjaWFlaIAAAAAAAACSgAAAPhAAAts9kZXNjAAAAAAAAABZJRUMgaHR0cDovL3d3dy5pZWMuY2gAAAAAAAAAAAAAABZJRUMgaHR0cDovL3d3dy5pZWMuY2gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAZGVzYwAAAAAAAAAuSUVDIDYxOTY2LTIuMSBEZWZhdWx0IFJHQiBjb2xvdXIgc3BhY2UgLSBzUkdCAAAAAAAAAAAAAAAuSUVDIDYxOTY2LTIuMSBEZWZhdWx0IFJHQiBjb2xvdXIgc3BhY2UgLSBzUkdCAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGRlc2MAAAAAAAAALFJlZmVyZW5jZSBWaWV3aW5nIENvbmRpdGlvbiBpbiBJRUM2MTk2Ni0yLjEAAAAAAAAAAAAAACxSZWZlcmVuY2UgVmlld2luZyBDb25kaXRpb24gaW4gSUVDNjE5NjYtMi4xAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAB2aWV3AAAAAAATpP4AFF8uABDPFAAD7cwABBMLAANcngAAAAFYWVogAAAAAABMCVYAUAAAAFcf521lYXMAAAAAAAAAAQAAAAAAAAAAAAAAAAAAAAAAAAKPAAAAAnNpZyAAAAAAQ1JUIGN1cnYAAAAAAAAEAAAAAAUACgAPABQAGQAeACMAKAAtADIANwA7AEAARQBKAE8AVABZAF4AYwBoAG0AcgB3AHwAgQCGAIsAkACVAJoAnwCkAKkArgCyALcAvADBAMYAywDQANUA2wDgAOUA6wDwAPYA+wEBAQcBDQETARkBHwElASsBMgE4AT4BRQFMAVIBWQFgAWcBbgF1AXwBgwGLAZIBmgGhAakBsQG5AcEByQHRAdkB4QHpAfIB+gIDAgwCFAIdAiYCLwI4AkECSwJUAl0CZwJxAnoChAKOApgCogKsArYCwQLLAtUC4ALrAvUDAAMLAxYDIQMtAzgDQwNPA1oDZgNyA34DigOWA6IDrgO6A8cD0wPgA+wD+QQGBBMEIAQtBDsESARVBGMEcQR+BIwEmgSoBLYExATTBOEE8AT+BQ0FHAUrBToFSQVYBWcFdwWGBZYFpgW1BcUF1QXlBfYGBgYWBicGNwZIBlkGagZ7BowGnQavBsAG0QbjBvUHBwcZBysHPQdPB2EHdAeGB5kHrAe/B9IH5Qf4CAsIHwgyCEYIWghuCIIIlgiqCL4I0gjnCPsJEAklCToJTwlkCXkJjwmkCboJzwnlCfsKEQonCj0KVApqCoEKmAquCsUK3ArzCwsLIgs5C1ELaQuAC5gLsAvIC+EL+QwSDCoMQwxcDHUMjgynDMAM2QzzDQ0NJg1ADVoNdA2ODakNww3eDfgOEw4uDkkOZA5/DpsOtg7SDu4PCQ8lD0EPXg96D5YPsw/PD+wQCRAmEEMQYRB+EJsQuRDXEPURExExEU8RbRGMEaoRyRHoEgcSJhJFEmQShBKjEsMS4xMDEyMTQxNjE4MTpBPFE+UUBhQnFEkUahSLFK0UzhTwFRIVNBVWFXgVmxW9FeAWAxYmFkkWbBaPFrIW1hb6Fx0XQRdlF4kXrhfSF/cYGxhAGGUYihivGNUY+hkgGUUZaxmRGbcZ3RoEGioaURp3Gp4axRrsGxQbOxtjG4obshvaHAIcKhxSHHscoxzMHPUdHh1HHXAdmR3DHeweFh5AHmoelB6+HukfEx8+H2kflB+/H+ogFSBBIGwgmCDEIPAhHCFIIXUhoSHOIfsiJyJVIoIiryLdIwojOCNmI5QjwiPwJB8kTSR8JKsk2iUJJTglaCWXJccl9yYnJlcmhya3JugnGCdJJ3onqyfcKA0oPyhxKKIo1CkGKTgpaymdKdAqAio1KmgqmyrPKwIrNitpK50r0SwFLDksbiyiLNctDC1BLXYtqy3hLhYuTC6CLrcu7i8kL1ovkS/HL/4wNTBsMKQw2zESMUoxgjG6MfIyKjJjMpsy1DMNM0YzfzO4M/E0KzRlNJ402DUTNU01hzXCNf02NzZyNq426TckN2A3nDfXOBQ4UDiMOMg5BTlCOX85vDn5OjY6dDqyOu87LTtrO6o76DwnPGU8pDzjPSI9YT2hPeA+ID5gPqA+4D8hP2E/oj/iQCNAZECmQOdBKUFqQaxB7kIwQnJCtUL3QzpDfUPARANER0SKRM5FEkVVRZpF3kYiRmdGq0bwRzVHe0fASAVIS0iRSNdJHUljSalJ8Eo3Sn1KxEsMS1NLmkviTCpMcky6TQJNSk2TTdxOJU5uTrdPAE9JT5NP3VAnUHFQu1EGUVBRm1HmUjFSfFLHUxNTX1OqU/ZUQlSPVNtVKFV1VcJWD1ZcVqlW91dEV5JX4FgvWH1Yy1kaWWlZuFoHWlZaplr1W0VblVvlXDVchlzWXSddeF3JXhpebF69Xw9fYV+zYAVgV2CqYPxhT2GiYfViSWKcYvBjQ2OXY+tkQGSUZOllPWWSZedmPWaSZuhnPWeTZ+loP2iWaOxpQ2maafFqSGqfavdrT2una/9sV2yvbQhtYG25bhJua27Ebx5veG/RcCtwhnDgcTpxlXHwcktypnMBc11zuHQUdHB0zHUodYV14XY+dpt2+HdWd7N4EXhueMx5KnmJeed6RnqlewR7Y3vCfCF8gXzhfUF9oX4BfmJ+wn8jf4R/5YBHgKiBCoFrgc2CMIKSgvSDV4O6hB2EgITjhUeFq4YOhnKG14c7h5+IBIhpiM6JM4mZif6KZIrKizCLlov8jGOMyo0xjZiN/45mjs6PNo+ekAaQbpDWkT+RqJIRknqS45NNk7aUIJSKlPSVX5XJljSWn5cKl3WX4JhMmLiZJJmQmfyaaJrVm0Kbr5wcnImc951kndKeQJ6unx2fi5/6oGmg2KFHobaiJqKWowajdqPmpFakx6U4pammGqaLpv2nbqfgqFKoxKk3qamqHKqPqwKrdavprFys0K1ErbiuLa6hrxavi7AAsHWw6rFgsdayS7LCszizrrQltJy1E7WKtgG2ebbwt2i34LhZuNG5SrnCuju6tbsuu6e8IbybvRW9j74KvoS+/796v/XAcMDswWfB48JfwtvDWMPUxFHEzsVLxcjGRsbDx0HHv8g9yLzJOsm5yjjKt8s2y7bMNcy1zTXNtc42zrbPN8+40DnQutE80b7SP9LB00TTxtRJ1MvVTtXR1lXW2Ndc1+DYZNjo2WzZ8dp22vvbgNwF3IrdEN2W3hzeot8p36/gNuC94UThzOJT4tvjY+Pr5HPk/OWE5g3mlucf56noMui86Ubp0Opb6uXrcOv77IbtEe2c7ijutO9A78zwWPDl8XLx//KM8xnzp/Q09ML1UPXe9m32+/eK+Bn4qPk4+cf6V/rn+3f8B/yY/Sn9uv5L/tz/bf///+4AJkFkb2JlAGTAAAAAAQMAFQQDBgoNAAAhRwAAOBwAAEshAABba//bAIQAAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQICAgICAgICAgICAwMDAwMDAwMDAwEBAQEBAQECAQECAgIBAgIDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMD/8IAEQgBgAJAAwERAAIRAQMRAf/EAQ8AAQACAgIDAQAAAAAAAAAAAAAICQYHBAoBAgUDAQEAAQQDAQAAAAAAAAAAAAAABAIDBwgBBQYJEAABAwMEAQMEAwEBAAAAAAAFAQMEIAIGAFARBxBgFBUxEhcIkBMWMCERAAIBAgMEBgYGCAUFAQAAAAECAxEEIRIFADEiEyBBUTIUBlBhQiMkFRBgcYFSM5FictJDU5M0kKFjJTUwwYKiRFQSAAEBAwcEDggGAwEBAAAAAAECEQMEACAhMUFRYXGBkRJQYPDB0SIyYhMzFCQ0FRChsUJSgpIjMJDhcuIFcLIl8dITAQACAQMCBQQCAwEAAAAAAAERITEAIEFQURBgYXGB8JGxwaHRkOHxMP/aAAwDAQACEQMRAAABv8AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABjHPFTcq1WtJtc3ht2mqW1muw6PckNRUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABCm9boqm2MZ5D3J/2Ll0EO9l/HIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAjVcp690+NinIDetFXYdgSM/p5AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEPr1HX6nR+IASet1diTr5PPAAB44auxn7LXOPfV/jZuAeDJvR9RvfOGNvargAAAAAAAAAAAAAAAAAAAAAAAACoiXZqlk2gBb9Fu2pxbwAHzuulwU0i2Q0xh7IHLl2OLEveHI21lXw88d4ta/sdxAAAAAAAAAAAAAAAAAAAAAAAAAAHynHWp7KNpmrgDITsq9bJ23TUAIOaUbGR/wPk/yWZ/SPUCLGsOZ45a9ZY2N73ydh/0E1Y506OAAAAAAAAAAAAAAAAAAAAAAAAAAIc3qOvrOj+ACb9mu/KDIA0vhzIEBdE9m/ANk5E8lhfj++4UGVY79DtT8+935kAAAAAAAAAAAAAAAAAAAAAAAAAAAURTrEC71sDyX8wb817Nz5nWy62PnRtti3me6AAlhtLhKWe1WEQAAAAAAAAAAAAAAAAAAAAAAAAAAANY1cdaPsYuMcgJ2Wa75YMiGOnewEatdMtgAZ97nzNjf0M1Q5UqyAAAAAAAAAAAAAAAAAAAAAAAAAAAAKvpNqm+XZH2Tsp9dJ5+K/bV66B7S+lNQA/a5RYf9AdVtnZK8gAAAAAAAAAAAAAAAAAAAAAAAAAAAABxXHW57GPH6um4WLetA6qZW/wDO7bPCPGehAAk9sph6Yu3eBQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIt3KKaJlnsX9fIilqfnOKusGaQAMw9Z0Nkv0W1K502OAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAML544OP/AFVcvz12u/CzcAHtzxYLvxq5tzK3iAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPxs111fPnavW+PPWgASO2FxPNXcrXwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAARd1kzLD7UvOwAGUel6ayX6K6lfW7WEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABhnj+/rb+de2nDiSAB5J8b06y7CzPj3KOOQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAB68K99A9pNTYt9uABv3OmM5x7t64dfafHtZi3ZZ2qwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAI4a8ZXhXpvsIAB93u+ssp+jOpMC/R9TR/Msb0oq7KHXSeaAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYz5vt62fnRtt8jq5wAE6N2dcM6zxjLrPdjGxDngW/xbtqUW8AAAAAAAAAAAAAAAAAAAAAAAAAAAABArRfZfSOGMiAAbtzNjqe29OtNJE2xXLftgZCdljrZO2KagAAAAAAAAAAAAAAAAAAAAAAAAAAAND4NyTBTSLZIAD63aQrJ/oxqRk3o+ohzeo6+k+O4ATis133wZAAAAAAAAAAAAAAAAAAAAAAAAAAAA+N1E6tP5x7d/B6PsgAJsbl68yL2ExUBQ9OjwPvUAeeV/UC/NazcAAAAAAAAAAAAAAAAAAAAAAAAAAAhBpVsVHvAuUQANvZX8LYHvtq/wC1XAGr6uOtJ2MXGeQG2qeey710n7XHIAAAAAAAAAAAAAAAAAAAAAAAAAGncQ+9r/0O2d8OQBkPf9XYt9BdVMs9X0YAFX0m1TfLsgC0qNduHiXgAAAAAAAAAAAAAAAAAAAAAAAABw4l6uj57bXYj5XuwOdOj7fy14SXG1uDcs9T0oAA4Z14ewjRYuUgcgv/AIMiZVmsAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYHVx1358bRVfAGVcOwjAkyWt1AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADD+eKV5lmA9+34Bk/C9eFImnZrAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAjVcorqkW4h3adU10/mWZRrttMW7kvHIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//aAAgBAQABBQL+OYuGGHx/YPRmQC1cmEmr2DpuMoztjsQSuP8A7LmI+sW7SwnL7/QfZfTQfNrTAYmAI+LbrrV6/wC+jmOaBHRWSjPQXZPWwvsEWbCE8dKecF7BPYERxjJReWhfQXb3WreeB32Hor3nqvsGVgeQxZMebGq+mp+ZY+PW/swei/k2Hr8mw9fk2Hr8mw9Dc0fMOJzxuf7B9c/1OUfrtnyyGaZcuPBj5JmMw1dpph9+jGMVkZA5BgRBsbdJ0KKSh57iEvCMm8iik0ISwfLIma41RnWRqRl+AMOJCE9jw4kcjrGAd50lGjsxGN27qwT/AGWLUdH9gpiGQ+c0yBA4/wCvkZlhsSxNmyiMhppx93HAjYIbvHfGAJi5+jpHP7MuxrUyWxAimijxgjT19j3O9Zhiw/MsfNCJwAr5/X4Icn5rrsA/7mTTjgRw6SZZajs71+w3X6z4ngfAmFZ2BYhEwjGsvO/CC7rlvuobsvdvxQDaCG728y1JZ7KwmRgmT6/Xjr/2seQ+1FYyAy6dJU9fY+rz2+9t4NZnGK9X4E9nWUR2GYjHYGQ/ddSCEPGyMaOzEY34VjwcG9kpxsENccvecoRFuXDgNoYZv999jVmUHFOk6cAx/wB5K9AdhH/6m6Qwt4wQgwmB0TfzxdoIMkPuynqcLx74eAUNCgtu/KqImXn1NkqcFx75OYqpanc3YKZtkvTud25ri2+59kXs41I0e+UmjR7AuD392B8CG113mkrBcmjSGJkfey5RgPAnzXyUynBcf+Mg5TkcDEwR44RyQv4/XjsBZDO95tkKGJ1OE4/8vP1+xmRmJWTeRRSaEJYTlsHNcd3nOsg+Lg0wYbxCYIFxw8DXc+A25njVHRufpiWRbxPnRxsQmRkFZtOBY8kKL5716+TFT9HSGef67GN3zzIFnzacPx9TZBE4ozLF4eZY4ZETwJTzhGWTMKyQcQiFoG65lkHwo/60ixksvMCiI4SBT+xGBLOh0fr72N7R/dJD1kZg3KJmyHs5evZy9ezl6ZElJFwrr0tLuEhRwVmp9hmUx2x17IwTIfLTrrDvT/ZjedCPQWSY4KysPnfXx7ASPkKaJY8T617KF9gi/QR4CKyUX2D0QdxjX08hzJPHyPWfcgjN2/QeV9S4Rl92Q/rZkcNSnXGdhtOQZrSt2ymXOve/Cg5RBgYegfxzf//aAAgBAgABBQL+Oe29PP226VvS2qnoS2/jX1oWznXHHoO277dfWhbUXSpx6Dtu4puTlP8AhOy8DAW/siAi/kmHr8kw9fkmHr8kxNDcxfLuJzxudl1LiVSpUeDHyLLphm7TTD79GNYvIPOQYMUbG3VF5ShU4WjN8gUhL8BIkSEL7DiRGCOscBuHSMaMxDY3axeFovt5TzmR9BA/yNyk0KYmTZRCQ23e85joVsGN3ixeUovThdTJbEGMXJvFyFOAgOd6ReFov+ms9O+5k048FcOEWWWo7O9N3UKvK5Yd+EGqqqtFttzl2LgrQY3fLV5TTl2n32ozB4w6bI04EAV57fbV4W5eE1nuQffdSEFPGSMeOzEY37nWSG2wY5xy91ynEQXwo3f777GrMmNqcJ04IB95K9AZ+e/rspEDHjBCFDYHxN/Olmgo1996U9ThuP8AxEH0BlZ5TZGnCMfUlN1ZbwlycLvudn/Zx6R0B8nNHQGBkKxOfFycpvhYmwIgTZkghKpwcD8dBROV+nlxN8zM+hefThYH5YhptP8AyhU4Xec3O/GwKYUR6fLFDI4iDqxeFovTlN4nTWB0QiQkFJtOCAPZxfNi8pRenC7vnR35CbTiQBTc9E4oReF+tCpym7Zgf+GgUjRsstLCiY4WBS2tN9u6vvWR2TMokZn+zl69nL17SXpoUTfUXgJWVcKDDwzNdt3KUX28eg0XjSKi03W/b6D+mrb+aPrq6zj0IlyppHE19yebrNfT+Of/2gAIAQMAAQUC/jnVPPK6+7XPoRU5pS70Iqc088ehFTmlF4/4xgBSUluIStf49/X+Pka/x8jX+Pf1Lx9uBZulyU2rUww7JdEgWB6avdbboMGmhdkmS/Le3VaUpxsUkRjwSffkTcTffci6MEkGRHXXH3N2VKUWjHxaz5XmYEHTnI8ZiI1ffa3aWI3kpe8KlKL4YYckvD4VkCJTlJTf7frrFxn9LNJUjYNiOOXu371clCaBjfkZiIiJRdclqGiakpe+L4tTTTd7zgyBYNiU5QURtvfVTnSeMXFcJSSnWDojrrj7u/iB1xKXbbbZbR9NHiXyMzf7bbr7gw1BsOnJyft2fQGLDPvupnzW4EWTIdlP7+Mg3kZbTTbDdOQlPfyvQAIZ8dEpyQr7OPpV0m/YyLSQ7TLlNQo8uU5Nk3L4T/zfYMN2fJjR2orFOSk/dyaLV3zHRnsYtORE/ZRdXb/jYz3kmmQ+3FYnTHZ8nSpSi7zGjuSn4kVqFHpyYp7h7yqUou8Y0L9qxSdKoOi+gAAv5GTTMmMQWCM90jKpuSm1d1bsudcHswx0X3DGvcMa9wxq+bDaSblMJlJpCUQcrVOKUXn0JxxSi8+hFSlF9Cca+3XC+Uu/jo//2gAIAQICBj8C/LnpmUbRcJtH+DcJuP4JQt90j0WI43r5Prl9uHfEYlI4ZeGefUJeGefUJeGefUJeGefUJdF/XwL1ZFZ1wEjKpjM1dwlTXsoya2cqLilBDhAaTu9QtMi4h9Zz/XfDav8Af/8ANWX0HoUKWytgJZomdIsl3/XpNKr+anHGoeqSYSDQEOU7mm847LNmsmn+shj3FyqnnLFeZNQxaaaPS5dQYHRF2kt+IkN1je3dRJy/cAJiHqDrgWsNCsppDbWegQ1IhU0vFXJuHOVUM6qWSTDQyQhwgMAG7/3ZfCbjM7O4P/QfghPNTaveTjkMzs0K8+xYFDW1cl2SrCRioxanj82n2C4YCiQdOgVPVFgArJNkkww8QaXhvVwCoaaydnsPQuMiTquHaWndeagLTRJ5HvvfNA+FNidFd5abZ3nsSLw6HqUv2pHzYbNNn+Twyu7ui1eK/hyJ/wBv2zkwoaIcUvFXJ4VVDTUDJLhwNVygMAuA2bZNa6I7c94qML1s5v8AsUtk00maEIBKyWAC0yDtfjXnGeHGxORNWJabdn2SXEPixyhJUTgJKjF0O6kJ+FIqz2nE3TvO4kfZQ0O8VVFWRNQ537doPkcIeIGF6cawjNWrFgsUJyIF1yTSo/Cgco7w5xEkQ0ONVyhLAMBtAVEUdqVQ7Teq/Ims6KyJF68LXii0m8mszaK5AvgyPfcZeHwo+W3nE7QC8eEB2kNJuAkYhLeyI4rsc2/Ko06BZO82iR3ZyeIL3l/yf7EXbQfJIU/cVS9wTYjPWcGWKnO4BxQVGk/CkVndWWCSIKGDHDtLBw5TWcdoC41bOkqQPiWahvnAGSoiIUVP1lpJtM7tMSn/AKL4U3pTYjC9WNB5I2g/aPcHVCMb1/NZzWWtneYxA7i4V9S6wMiazmFp9GMsNnvKIU95fJ45+FF2Vf8Aq28TncDDda8OgWk4AU+ymTuBh+rdpZlvJxJpMm7PrjojkpFAtUqxIy+oU2SXGRR1n7wtPAMBUMJ3mESnvr8UXpd2D5uUflukyY3Zzs0Me4uCQOcr3lZLE6fendqiB3GHIJ5yvdTjerBg970Nms2a7A4PfYgfSi05+SM592c7g4cNfPFMHCcBWcJIgYfkprNqjao5fUKLPRhs88jYkscu0tPAMTUMZLjok/dWdAsAwAonebxI70+TxOa74V1/tZeZmM3DZjyyHPdIdVPOefwpSMdbCdrvh/z3JavG5Ge3m3EiTBVMbNZsv0UOe/v2hPNFq83u43sM5MHBpa9OgC9VwH6CmSYFxSylSviUazvC4ACcya3ZVT943UQkkspNFNUlxz928poSNU8VNieG8tMuqefSZdU8+ky6p59JkxzDvlHBCuCQV/YMh3GZS8wFAznNLoYFGq2s1qVlO4XD8DGbhtDbtKpm4bRaZlH5dH//2gAIAQMCBj8C/PQ1ku9VF6qP19UuM9dtz/pLrkaDLrkaDLrkaDLrkaDLXiolCcNUknINw2Vb+GHDkaz1Rol0r1jyLvsT+3h9no+4pKW3lkzUTxoo1C7E8Fsi/iFazw7tG0Dtj4d5eCjmp4TXuPpeLiG6+sRkYas0njt40ukKGrvjdf6OlHXKoSMeASL58dZ4o0naB0rzwruk4mxPDhlmdM+R928UNyy6GHSEu5FayxADTIvj1QoSLhwms7QEuHQa8UWCSYZFlZvNpneWOcCv2hO+c2O0HzB8Pur5P7b8/syzi+LOlNCReeAVmRevC14otOzbZrF+GRSreTn9jZMFU3WVQkS1h4dFCeHPwDaAl07DXiiwZ5Jh08utRvVuoGE7y1yfuK5eAuz+zLtB8yfjje5vq3hnwnKiVV2C9Vg3WSU+elrxRadoAdU9AKVnDhNQ/SQQihADBNbL7Z7sihO+c/sZtACE0qMg7V16qVZbs3DO7C5P3Xg42Cf5ezLtB8yfDiihGW1WaoY5Jyol5ZULzYJKiHxa8UdoCYdPJrUbk28AxkHToMdpFAndE5PdHdWJtVvDDLtB+54ldKt5Ob2zuyOvEvR9Kf1qGfaD25/1Ls8XFX8fbknKiX3ISNOGeSol7y1HRhmq2gJhnVZ9QtMkw7kMdpG7TO7K5PdnfrVac1Qz3zWbOdM98S99QsG+dFk7oHfiXvqFp3h+m0HtL0d2dHSqwZqzmvnKiHvVpDZKiX3KPqFg2gJh3XWKMkwznkJGm8553YXPUuzxsVfx9ubaD21717wUYJ/lXkZO1XZ72vk4c7NZjn2g673wzuk4mxPDhlnGIiCxA0nAYyMS9ouFwu3W/hs2VDpPKUWSTDO1oorLRSbTusly0aRLlo0iXLTpEmvHrsfMJMhWvXuhPDo0y6SJU24WDIP80U/l0f/aAAgBAQEGPwL/AA5p9L1e0S9sbgASwO0iVoaqySQvHNFIp3MrBhtJqfkm91HVtP4nl0iW7kbVLXr+EOZBqEIG5fzt2D4nZ4pbq+jkjZkkjeadHR1OVkdWYMrKwxG2a21jVLcjcYNQu4SPs5cq7L4bzXqkqrT3eoSLqiED2aail1QfZTaOLzLodpqMe57vTHaxuqfja3lM9tM3qBhG0dvpWsJHqEo4dM1FTY3xb+XEsvubqT1QvJ9RJdT0zk6R5moW8WE+E1MheGPUo03SGlBOozgd4OAALnSdYs5rHULR8k9vMKEdaujCqSxSLijqSrqag0+kMpKspBDA0IIxBB6iDtFp3mbxHmHR+BFneQHV7CMYVimk/v4wPYmbN2OBhtb6xot5He2F0Kxyx1BVh34po2AkhnjODIwBH1DKSCO01y0jb5VquXiiPe8LdZeKWxlbeMTGTmXrDXmjavavaX9jLyp4Xx6gySRuKrJDLGwZGGDKQR0PFaXNzLKd4/mWlTH4S/iQ7jgxguFUnJKvEvrWqmz1zSJuba3acSGnOtbhac60uUFeXcQMaHqIoy1Ugn6hC5sVRPMekxyvpz8KC+hPHJpkzn+YRWInBJOxWY7S21zFJBcW8jwzwyqUliljYpJHIjUZHRhQg7uhDLJJI2hahJHBrVqKsOSTlW9jT/8ATZZsw62WqYZtre8tJkuLW7giubaeI5o5oJ0EkMsbe0kkbAj/AKDI96LiVSQYrNTOajeM4pACP2tvd6beMva8kKH9AMg/z2/4u5/rxfu7f8Xc/wBeL93b/i7n+vF+7t/xdz/Xi/d2MWnaBdzlaZ3NzDHDEG9qWVkyqMD6zTDYVwPWN9D9uFfSjefdJi93M8MPmG3RT7uUhYLbVFA4RHMQscu73hVsc7EdCXyLqU1ZbZJr3QZJH4nt657zTVri5gJM0YxOTP7KDpS3d1IsMEC55HbqHYBvZmOAAxJ2aC2Mlpp24QhqSTilK3RU0YH8HdHrOP0NyYZZcoq3LRnoO05QcOgZXLW+nRNlluKcUjbzFb1BVn7TuWv3FLSyhWGCOtFG8se87seJ3btPpW60++hS5s723ltbqCSuSa3nQxyxtQg0ZG6sdr/Q7jM8KN4jTrply+M02Zm8NcblXPQFJMvCJUYDd0LLVtOma3vtPuIrq2lX2ZImDDMNzo1KMpqrLgajbT9etaI06cq+tga+D1GEKLu27cquaoTi0bKevo/LbSSthZtxshqLm6FQz1644u6vbiez6bGOyVRC9tDNnUYztLGrtO53s0la/wCW7a0ngVUnvIpJLpV6yjIkctOoyCvqJWu+tdkhIbwsNJbxxQZYge7UgjNIcAMf0VIitbeMRQQIscaDqVfWaliesnEn0vJc2Ntztf0LNe6dy199dW+HjtPFAzPzYhzI1HE00aqO8ej8r1K45fl/XmSG4aRvc2GoDhtL/i4YozXlzHAZCGb8sdA28D01C+UpCB3ooK0mnNKFarwqd+Y1Hd2r2/T4W1ugYB+XFPGkwirieUWGZRXqrl9W0l3eSma4lpnkIVa0AVcECqMqin2bRwxKXlldIo0XezyMERR62Y0G0dqMpuH97dygYvM3sZvaSFeEdtK9fpka/p0YXRvMc00vLRSFsdUwku4Kd1YrktzY/wDzUABBXoR6XeSf775dggtLrM3He2IBjsr9a8TNkTlzb/eDMacwD6J7y5bLBbxtJIeug6lHWzHAeva5vpSfeOeUhNeVACeVECAooieoV37+l89ulqOOOwjPapyyXR6uFgVX1gns9NX+gagKJdJmt7gKGksr2OptryLdxRPvFRnQsu5jtf6NqcXIvtOuHtriPGmZNzxtQZ4pVIZG3MpBGHQTVNNnez07SIHbWJ6VjuYLpXji0wr3ZHu5EzCuCCIv3lX6Pk1tJ8PaGt5TdJd/y69a2ww/bJqOEdKK0xWBay3Uo9iBCubKaEcxiwC+s9m0UECCOGFFjiRdyIgyqo+wD03H530uAtd2CJba5HEtTLYDC3v6LxFrNjkkOPuipwWM/Ta6bp9vJdXt7PHbW1vFTPLNKwREGYhRUneSAOvbT9Et1jNwsazapdIP73U5EXxU+YgMYwwyR1xWJVGzctqXt4HgtKb4zl95cVxFYQeH9YjqrszMasxLE9pOJ6KRxqXeRlRFUFmZmNFUAVJJOyxuo8bc0lvWqDxY8uEEezCp9fETj6clt7iNJoJ43hmhlUPHLFKpSSORGqro6GhB3ja70sgtp1xmvdHuMSJdPmkflRsxqefalTG9cSVzbiPobz1qkPxN0stroEci4wW1XhvNQxxD3WMUe4iMPvDjaa5nbJDBG8srH2UjUsx/QNprx6rF+XbQn+Dbp3F6+Jq5m/WJ6Xzy5X3MDOlkpH5k9Mrz44GOEMQP1/2fT1xFBDn1vShJf6Ky5c7zBR4ixq29b+FMoFVHNCEmg2j06cSRaVp/xetzCqOltG4XwkZNMtzeS8A60GZ8ctNobW2iSC2too4LeCJQkcMMKCOKKNBgqRooAHUNvkdo/ChV791PfalUt8MMsdczfr03ZelDZRVCnjnlpmWCFe9I277BuqTTaG1t0EcEEaxxoPZVRQesntO8n0/qtxpdjDaTa3fvqepSJXPc3bqAzlmJKpWrBBwBnYgVY7SXHCbqWsVnESOKUj8wpWrRw1q33DCuzyyszySO0kjsas7uczMxOJJJ6IUYkmg+07RvLHl1C7US3JcUkiVsY7btXljvD8f2D6gPJIypHGrO7saKiIMzMxOAVQNnuFzLaxKILWM7+WhY53FSvMkZyTT7MaV6Xze5T4eyk+GVgCs10BXNQg8NtUNX8dPX9QRods/vJQst8V3pHwvDBXqMneb1U6j0oLGDfIwMj/yoVI5sp6uBMfXu37QWVquSC3TIg6z1s7UAq8jksx6yfqBPevlMgGS2ib+Nct+WlBQkDe36oO0txO5klmd5HZjUlnYux+9j0vE3CU1C+VWlB3wQ4tHD6nNavuxoPZ2s31W+gsVv7+30yzMxIE99dki3t1oDxPlOJ4QN59Pkk0AxJOAAG8k7ERn4KzLw2q9T8XvLg1AOabKPsAA9Z6PzG5T4GxfhB3XF0KMkfY0cYOZ/uG47FmIVVBJJNAAN5J6gNhFp8hOhaEZbXTHGHi5WKeL1Gm8C4eILH/pIpwJYbQi6n5mvaMI7LVw/5sveFnqBxJfxkMfE2FZkfClPT3ye1YeIvEIu2GPJtWFDF2CS5Bx7I/2gelb2NsKyTyBa0JWNfakfKCcka4n1bW9hb/lW8eWp3u3ekkb9aRyTsPKmmT01bXoW8cyd6z0ZqxyKTXhl1Jqxjf7oPuqp+iz1iLNJZt8JqtqP/q06Zl5ygVHvoiokjP40FeGoMF3aypPbXUMVxbzxMGjmgnQSRSxsMGSSNgQez05PfXBFI1pEhNDNO35UK4E1c78DRanq2nvbls81w+dz9wVVA6lRAAOwDpfMLmLLe3yjKGHvILXAqhr3DMRmI7KVx21DXtSdVgsoGaOPNle6uSKW1nDvrLcy0Udm84Ana+1vVZuffahMZpmxyrgEjhiUluXBBEoRF9lQB9L+RdUnrNAsl15fkkbF7dQZLvTBU1JtwDNGMeDmbgqj04ttavm0+yqI2B4biZvzJ8MGSgonqx6+l4m5jzafZ8UtQpSebDl2zBjirA1bA4ChpUfRb+WpoZrPR9MtoL20VjwapPdo2fUuE5Xjho0CVxRkk/ER0LHVtOmNvfafcxXVtKPZliYMAw3PG1KMpwZTQ4bWOvWNF5y8q9tq1ex1CJV8VaP18JYMhNC0TK3X6a8BbSUvr9COHvQ2hqskla1VpSMq/fuI6VvZW4zTXMqxp2Cu9mONFRcT6htBYW3diHHJSjTTN+ZM+/Fz+gUHV9D3dpH/AL7oMc95p5Ucd1b5Q15pxoCWMyR5o/8AVUDAMx6PynUJAuieYpbe2nd2oljqALpZXmPAkTtLy5jhwkMT7v0zNe3T5IYVqd1WYnKkaVoC8jkAes7T3102aSZyaezGnsRIOpI1wHS+bXUfxV2AbXN/BtSuEgBAyST5jjj7ulO8R0BrumW/L0HX5GkyRrSGw1XF7m0FKrHFcD3sQwGLKoonRXTr+45uvaAqWt3zD726scRYXuOMh5a8qRsTnTM3fHpg6XbP8HZNllpUCa7GYSdfEkXdGG+u8EdINMvwFmY5bmtfe8R5cA7eaUObsWvXTagwAwAHV0NR0C94BdxVtrilTaXsR5lpdAAqWEUwGZajOlV69r7R9ThNvfafcPbXEZ/EhwdG3PFIvEjDBlIIw6Gn69Z1ZYJOXfWwbKt7p0pAu7Vzu40xQmoWRVbq2s9TsJhPZX9tDd2sy1GeGdBIhoeJWocQcQcD6W5UDUv70OluQaGFFyiWfD2lz0Xdjj1dKOys488j95v4cMeGaaVvZjSv/YY7R2NvVspLyyHAzTNTPJSpy7gAOoDpQ+d9Mgrc6dGlprkcScc1jnpa35y95rJ2yOaE8pgahY+ivkTVpfhruWSTy/O7H4e7fNJPppzcCw3ZBeOlPfEjEyYelJriTNkgieZ8il3yxqWORF4magwG017PbXVGOWCLlSlYLdSeXEvB1A1PaxJ69v7W5/oS/u7f2tz/AEJf3dv7W5/oS/u7ZYNOvZT+pbTNT9qicP37K+oFNOt95DES3LDsWJDlWv6zAjs25NhBkzU5szcc8xG4yyddK4AUUdQ6c1rcxRz29zFJBPBKoeKaGZDHLFIjYPHIjEEdY2mWCGQ+X9Sd7jRrniZVQ0aSwlkNfiLNmy4kl0yt10H0xzwSPDNC6yxSxO0ckUkbBkkjdSGR0YVBGIO3gdRkRPMulRKL1MF+YWwyoupwx+tiFmAwWQ1wDhR9QrvRNYtxPaXSGjYc61nCsIru1eh5VzAWqp+41UkHwmqRc2ynaT5bqkIJtL6JGpvx5FyFoXibiSvWKMfptNY0i6ks7+ylWWGWM76d6KVe7LBKvC6HhdSQcNs6cu0120jX5rpWbGM93xdpm4pbCVtxxMZOVuot9QrnR9atEvbC6HHE9QyOuMc0Mi0eGeI4qykEbSaj5d5/mHRRnd0jirq2nxjH4i3iHxcSr/FiHUcyKMTT6bbVtHvJbHULR88NxCaEdTI6mqSwyLg6MCrqaEU2i03UjDpHmYAL4Nnpa6mwXil0x39s0qYGPMXqLgEj6hz3N/pfhNTnxbVdLfwd4XpTmSqA1pdSeuWN2w37SS+XNVsdagrwW11/tt/T8ILGWykI7TJHXs2Pj/KutIo3ywWcl7bj7bmx8RB/7bUls7qMjeHglQj7cyjZJYVuIpYnWSOSMSJJHIhzI6OtGV1YVBG7aPTPPMd1qVj3Y9bity2o224DxsahRfQAe2PfD/U3CHU9HvYNQsLgViuLdqqab1YEB45F61YBh1j/AA5//9oACAEBAwE/If8AHNMCsUMxQt62JqK17FNfCWCDQVFOD076lOCAiRoHa5YO6Uaba9cvo4p3Ls6UE9R/0F6Pc9GJUvJRuaf28iXvIqIda1BNrAljhc0ggI4Sw5D4o7A0ugEIEjp+C2PdXB9psojprI7gu72rE8mPIdsSv2Wvv9CI51mBMgBaYrTa2ITYfvbNsoQMDytjaoR8YRkvUM3KHkM5zzzwB8AT3G26sdgM+4UgwBRDskAl1WG5FHGRCQ3QhICnulIVyO9QKoAKqwAZV4DRdHMvITwqEs6W9jfI5ja++fP28oWwmJChAuUBa1IhECBhBYQgHmDqizVxhnRMWSzPahZgio+OQ3LWIDahsuCCABKUGVACuheNUt+WPVyqwS1aJin+cGA5eNIjCQ9nxOysWNgzMiakLLGqZ4iWqygUMovGA6rhum8HyVCUDIjrnR6hQoYIQlM7GaWkQ7WaoKSaIjvf32RVUJGJIUNiMsKRTU89gpWox0EoGVg+depfzS+J5sECAAuUtIHl40GIRhJ+CUaIkdsZlRKzENSX1F6GglMqQqVVV6vKlAs0Thl82BhKiKNJSbENaywZblY9zkLZNVALSMJMhkyKWlUq1KvdcvjDQ7YmbCSnmXZdKTxNkcRQAQUAwaIfsEnB1J4crGispYZDuJD0SRFnWUo4zFwxfTECUU2BREYRETIlieo6DNAkwJVWaywWgtRnLUmHUwlgOUGqCTkmfY6gkk2srtMRpBkjATK48RUj60bKNa6NVT4KRLoLltaTrCHSmXQ2AdsU7bWQsEBjunOVJGQsISoyJCDIptIkdSkpOh3kSBRDrGk3qshLHIt62EPLq2eRlmZSY8TECpPYeDpK0F6toHywWPpMiSioSZTKHVYALymq0NGbLK5H3XaJSoo4nXoAJdUEhqYkBROkSJIh64c3/P1wjRESHT0spktJBzwIT3Q4cQkURJIVDBbAAcWqEQtTAW6GOs5MhksTKBilUbhse0ebqKAMzeRv12updkS4By0TxGM7sazQFAc1gtDazgUih01BGnrksE5fTggywyW2y5qhcCjjSwJhpEzrDz0+2FleUlEtvXyhtOhyRNIjYllTaBMoAeIs5IHTzXDOMtLyrl2mTDB3SA++sBcnQRWmFySZoDr5l0vOMNKSrg0fqiNI9C8FAkgNzJYoiJFmQQhwsB8g1NqNkohmLFTHmm4foplCiYmWCSYCwagki6My6CMgSnyA47d3BSQhzEjpfdoRcPovztBWAV7GscpkwWDbEK8jgtAA063LXACUC+vgmOoACUKANNqDVMCMgWhCkSO4UZwUbFdoEBpuFYOgB4dKEAC3SBjZTbsBVHsuuLzZVTDRNdNKhWddk14tL+S6DNpjSzba5W193nbfxTqDMYQLgwF0SrCJA9YOp5ihYK0N4ZvDUogEZ+atX9jbFRZJ+gCSWpLd6w99BrUrrk12oLRIKw2IJSFpZ8oaCMCgL4RxtzAWqAd1oD1XTJK4mJhwEVnQqCC+RaE6eFhRBWIh39IIhFaUWnDPFlR1bGexD06l65ybgZ+goVMUW8xmbh43xg5AIIhnsbqlGIUgMAGG0kTx/mLS6bbucJSaTha/ZcFeHAWK9asQ4KhQ0h4YMDEDr/vy52x6QzJJrCyPDCOgYmaxvlxcUljFgeB+1gkKLIgcLCu2kzrhwpV8PbVwHrB+MnQ1LAa1DIheoLLImDTXA8kFyy7hpkpEvFmnQeQDYogQS4I/AVrwN2YoyUmNXMlhndta5PMTJ1dwatbltxK3iCxQNt5YOASkMxqxBbIAAAAEAKACgDY8xbRWyhCpF0Hq1vaQRgsOsuSh2NYSmMWkmGIgyp0f7QAdsylmJwCJ1aKlHhYgEgAZUkNzSqVtWX3dq6lykgUFCGs5WAUCxwA+Fl4gQgsIVZXaNSYBeCULed1k9vD9kwZQy0QjidVicyR+ViV0lro7pt6gaBEgAqE7HHjxJM7EfOEAi8K0wwJTiuDupySWNKyZxssiCEoUlgneehveSIsTEJGkJBmf6E/dEq9gamthRm9LAJNXwV54rkA0TwDyHoaLCIIDUbBpFPR1hZ1xUiSSRUIX2F+ABAl9RdLhJSaBPe/ul+uywc8+Q8OWJMQke2SL0UbzUWdo4yo0kCNCKUIjCNInjxHN5UMIayw5Jpp1+zU7mRJA8iQxMuYwwdwQLQBho8AkFmEittPPoY0hLdHUBaBkGaaRMaEwKQKEdFMJfhDAogKJNR3aY05G2sMyyTQs0SR2X32HrQf45//aAAgBAgMBPyH/ABzCjJnSKz1WoNLcaDlrJ48iJV0EEmNh2o6Uoc+Q0XpoQSY2E3pHD5Dmw/8AqZi3GjoohNcnEPy1hn0kAfz19G/rX0b+tfRv619P/rSnLQ930HfJ8mpA0h1Tm7eHunMHXB+VWALQAV07eDB+ZHHYMOVwmsIrNMd2DHzrFOfFHEFHb5lqmbUyKiGEWDK8pleVK9VGGTOj2RBIcbqYeaj3wp5u4nBV8DNYi4NJynM9oCAGnQRxCgMHcTse3hwaSdzJiT2cAY8F+jB+1bVtKqqvV8tltsjDYgLRTbV6SehN7C2Rqpwgl67HNrXk6zyxTBwGC4IFwXoJoxJQgAWq40Ewmd7lg/G9jkHrFY5NtsZeAO0G9uDukZCAt1MwcvMFF7cECwm4fDE93v6hyTPrSRNCJJjYwi58FKYZTjmzyLZ65sbquRJxtg/m7aaBrQTYBAfB1uC/jIW4082gackamnvA+5AEOkTqsqsq915XvtOs4CVGADlWg50SIw+yUtyKymEOKnXLbnw4OvSTUQSv2MFupP8ALPZPdeeyMA2lbmF++fUT1ojbrvt2rbnwbhsXMiX7CL1ZI2yuCerB3bhtpC50RUY3AQe73W1tvr6nPGpGKd3YyO12zEzSTc+7KJT1Vl2grAVdtBQK7v8AQNPcpHkBzyEMAJVeALXUGoJHY2zi05CfdNp8NOKE9YL9e4nkGDqox7nvY9YrQ3duAuSw/sYJJJCdRyoDn1XdJTlL5AlFAk/sSdmxmnOJyyc/oCggADcVMlTO7utYOsZJNAuOvqBLjTJa0/7TkfBMNwApJJ44+wO+1JBrJZa9+deWozAbWTDsJ6Cl2485i+mT0yVyxAUCTdSXKzC7r1HU6WDwpuu2b5TCK9YvexUtWn1OPTsBAcAN2IGc7B9JR7MEFaSBoAQY8eH1whMUDGP1BHNUhw3ZAzFjP2QRHeQR4A9TYgkONNM60dGSSN4/fvh4mYO2HMeaCcwTASnAXWJvsyb9Yv4BQ8KZy23hk6zNWTvPbuJAcoNTCpccfiSHPLKruHtPHLWPwnpgqHZWOG20MuscoJMxFC+3yBWbg1EReHkee+OJXIgAIG2ggkxsKZpIYc9WfGBfMX3pBLmNC3c4avym+U5WAUCrrMoIY0oYwBdoYl28vbNXPVcByIwBUC1goLdFxnBprFXEyuWAnX0D+tfQP619Q/rU3+7r+aaVrmkoPUMneY78agPonsHPPzAQJYP/AFpJky8hooZ0bJsQSHGkXp5DFUmdDSjsQEONJc8iMPjwAXCak8Bbz0ioc/45/wD/2gAIAQMDAT8h/wAcyTpePCXwBc6A+RPlaSM7EM40I48h/I1EZ2C0GSTyHE9dsj0/8SEi5fxdSyt6B/rT6S/evoL96+gv3r6a/eo45wPYSy++HKaYmsdZHBuQ3AA+qDKtBbWj3sh8Afzt48EH2BBL2nOwYAfLQ+/E4o2hLdKg5TwdgwDgK6sIY2Ys0pJ2ie8DlwfyvSCsvBWoYjxQCcGHvbc6ZkATLEjD6EDHHgaQNy57kzBb8Ekmn8yicv1gwFFdXmPXbE+mwUbKJFZ/U7/ExDZKUclfsKffProgZ8HfuuV9W9BWSRwASr7GksfgT6f7CpgOsxM7Zj18Iozh79+wZXgl1ZvH3H8jjMEE1uguuz9Lt8ScOtJJGmq2B8A0A4LxX73h+Nbs6i58vp+AqplNI6YR5W163wNggjUcbB7/AKnd/MEWaBFAINqdwCq0AWr6Gk3OD6Tfvz9DsT10Q+HI6hLGHdUGo6X5Ay+xWChzO7hAlHunvqvxZOvYnroS+AT6Uhe1nyXJxK5W6ClNNzf9H0LpwDCd1+scdfgNQ/FI47Z+kmIWjaAgMAEAegbVBLBqUs9uf7WPR6vIBAqgAyrQHq6iSzfq4PY17y53KEa4+GPex8+x8gytrhef+werCN1zwfcfyOXgl41YuZ/QegUHAB5AlLHQ4MvfuVINAOjA4D6+d2UqRDH84e7yM9THXwVgzoDgZzt9CfU5I3BK2Z+yvvf5EiE6maxpydejdNF8s+1H1hdjc538xcD1VH81pp8v0HA9BA9DUBHgpT13Kf28BaegfdgLTVCJj9r3VKvK7stVuMfzh+cK0WCdLLPXwrBQKfP7t+7EMnbfsAh9v0X+SU8CZjjZjQyT1rLwDeM3sfgEjceWFr44PVaDlQ1l6aOAweh/LK2vhMbYn06yGswj07r6Bb6GiMiF6rk9Vb9io3LPcwcfHth88wtkTPG2Y9esVLwiXx/NP9jcwoKDkcr9meCGiqy52JJGsbBhnq9KY/piGF9CKQ7v5IKOA5X+2AXWRZQYPA/K8pYJjdydaEYsUSwSsErQerp4RtmP1Pg7AONfTX719NfvX09+9Rw/r/bpOfCpD3WF8L7M6x5MFfWZteV/8JHpt+Z5DSSNKy2YvXyPIaTnSmMbMY0L7+REOlcbQZ/xz//aAAwDAQACEQMRAAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAurmwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP22wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEe2UAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAC22wAADhJFuAAAAAAAAAAAAAAAAAAAAAAAAABWyoAAUkaXQAAAAAAAAAAAAAAAAAAAAAAAAAHO2PAAyCC9AAAAAAAAAAAAAAAAAAAAAAAAAAAi23AGCS7AAAAAAAAAAAAAAAAAAAAAAAAAAAAE2yoNSSTAAAAAAAAAAAAAAAAAAAAAAAAAAAAA+2oSSSRAAAAAAAAAAAAAAAAAAAAAAAAAAAAA2xKiSS4AAAAAAAAAAAAAAAAAAAAAAAAAAAAA40gSSVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAH/SSSlAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwSSUYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA4SSVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAKSS3AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFySSdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAApSSSmAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA8SSsmyAAAAAAAAAAAAAAAAAAAAAAAAAAAAACySU42xAAAAAAAAAAAAAAAAAAAAAAAAAAAAADSSTE2xYAAAAAAAAAAAAAAAAAAAAAAAAAAAA+SSEEm24AAAAAAAAAAAAAAAAAAAAAAAAAAAGiSSIAu2DAAAAAAAAAAAAAAAAAAAAAAAAAAAASSRwAX23IAAAAAAAAAAAAAAAAAAAAAAAAAADSSEAACW2wAAAAAAAAAAAAAAAAAAAAAAAAAHP7k4AAEu2wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAn2zQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD224AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHqKRAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/9oACAEBAwE/EP8AHNEFdIkZIglMteigQG4CXmSjmkwSj0eVSCEnIETSKSAALk1m5IvSEHFHxjaFCYIIanVnWsCnEpLkR0pEYrLdCWYEFmEnkOMZO/qJStLkaYWioCrDt50VFPAGvCsa+IAIiCarLqYYWI61MNLZbabCjS6pOUKfIRV151J3ZTJXQehYw4CrnNk6o58WW5hnIJ3g7NVQaiqjmeV4KnkMdH5viAErD/SBgR6lHCFjDFAImxVCtpsDIRogDkcc5uYyw6G7zDOeCKggAlWg1GLAImMkGQwJEjBgSYSR3Fkeq/vst7t3a+r9enZAxUDibIlP0aRLbcC60gFguDHVGPUPX86FEKE2rhb2ZgFphAI7uETyX7PDESoLYC0TiQ5DlYBLqZVVVVtVlXura6eCoHswrslCBbBpEoGEER9Rs8fdBykSUuJK1DvrmLgvTsAAgB1QEZ5JTqzv2wgR73ToAcEmkKQ3ZHXDdGo5e1wMvFG7cDXx2oO3tl2RQkzfEIcKLvChKQBISqAloldJtJgE7RlMocOjriSkDD08GcAaP4bvAVSkWvHL+hmJZvKl5hkdWgIgkaCQAyEA1UEFCikRhH1HZMtyV0TGVIYTV4w/dDSNc0U6Ukc1UbKJTuq+MeBKBqGGGxK2BrqqwiS6+IUoCVAOz2xEpghC006msuqIOJCnWRkFhL1MC2KlevSiZZiICBYCR4dRIcZTX0Y4JU8GRCUw9oBmTl8J1A2jwgzQUbBF3eg0zKpXEommYDrTiiVigACwZLkVpyREVN06K4KnxS64gyZIESM7wmy63sLMSVgIbpK6ZqJjTaEOzEsoVJMqFCJTkVVetsebAUHh5Y7Jf4Koa4gBH+MxgqHr/wCpOUEWWAtILM6ooRBgoSzEei9CGVCkqyp2iFo9RDQaBGAXQPDmmJE6uDnXeuJRzYUnx+iQRTTnxitxXkGHgIQngHjr3vsKNaICGlgBi5wCkAKhoyieCQfNio2RiNpwnDuUZljgSx1486Uy9CApsF7SD54AzJMtGWRNYzZp/wByvjAQAacTGbgT+1QMQc7o1umQ0UEqWLbkysUdigLgMikdRevFcBXiClU2qHbFzDxjyY2AwlUKllUOSAjCKit7X1hfkg3utLrDhJQUSsrhb5AK8w7eSMgnACtaUN0eCLaQpkv22m1Rug8IrWZCK+QBitagjLGQAhsq21NkEEqMaGZSU1pqrSdHMwAEAJjyAymJIF20YRDBEHTtamKwLijEAqANopQwCry0djPY1ispBa60qEgBdUrAX0IcyBii29fOgj+IYQcqqAGkggQQABSOImzci8p07RlIirNLJFMTMb+qlEAJdKFBRfujkSkiyR8A+GtBKoJL9eyXHclEyFUthTEVSihUKG1RVLlbduKCTiipKgQSBQL4HBIVYJwkABEcQexVQS56SdPWyqqqqqqtqrarpUU06pNRJblYlVe8Yd1wBFSnrgdOeLzIFJJoceO8QgKCj6qB2BtBQEACVAAWogOXRGlWii4FhgdCjsqHPxQdUnPr2pB07sYlI3VC+Kq1Sv2h2OSYf1sQoRY0y2ZlA4ibWKJIdqMA/wB+d/CHb/SMz0cc2G2K8Ga1JNEkUq6iBroeO6TBWJEyOswsxB+uAX8dECVVVlVS2qKl5VZdsqcEJnII7EmEHR7W44KSRrZOgiael5nNEE+9SmkRT9f62JZpgrRjmuHrO+iPGWAZRwSAFgHaKClK4KcJlSNU2xg79bK2DKBC2NAgNUplXMokOceIJFAoiRLGxH5rQJaxZ6VgGMCBdY1FvyIaogzuCcIk64SydyTwqwINA/1ANg8BIAoNgrHgN64YsGymmUhvOoEO5yiBPF7mUJrcIsXrS0VL6B4ssw1gI6qrhZCB/JJgO05y5JHlJX5XaJ/5xLPKigr0Hy+2aUOmumDFuWJA+gblQkRVbGe23pytA/aSvqpUX79XnSAsILdS1FM25pqDMJJsaNGA6jW8SRUcIKDaYvUnmFOpAuCllKcnNYZduo4KGuKdz0ysDHTIMyhF0DDOZcmkDEoqbChw38UfkoYEEHVwZBaxx358hpkp3bwYj8oA6SIKSQUCBpVLpths0seJCpMgAuDpZZU1XLNsEQfkMpjvzngV1YRLoA750iAEZ1OoBcHpOGUEIjYieJ2JGkKZ1XRUUS4XrJZ3rtr5EuDbrKzqAmB8gCFKSbNwTWgugmRIeppQ2WKWgYXS/hP7kKnQiCOdD804Lxu5ikEHQiTA37QKBcb9GQfouqBpUWtIV/jn/9oACAECAwE/EP8AHNOmBqkQ7or57fj21CsD7Gl8h9tZEfFfjS7QfW9Xh9xZ5E5o/H2/rRh5Wz/VK/1qKceQ0sLeT650YeVsgWfD2/16aenf59TyG/Oc+nr/AH3+2skmNhxcMP69nSIw0m9QKQNJmEDGRRFGkFGRJGGshUrx7Afd77K9+/29TVvBGSpcuxICEZNaQCKJBkGLBgkGhgnMGOqTH2/6/rbC8TT+n5xucWTBggAErhCQwEwRGlCRn7oS1/hA+QMEkUiwwwGGMOkUhAYTs9nxOV4c5o5ZPLhVa4K63CwgXwpPhEsAHVECgOiYzz6POxEUrTquP5ONt7FJhOHkUJQmReFQJcGlWpTJIttVhQQwRQBYkHOM+bBKrfAAJZXpgmUzuY6JRplgwaX3QXlpkdWpVwP6frjbUH7Dk/rYG4IUQtC5CqyY6sAEGDxvN6bhKzvFbBSAo0YhkoFQYaVaigVLygaFhsoAAKrooXnuH5jj0EyOsg/61HH2w/G34wPR5PBeJDiYwNScCo4gM73AyB+2VChIoQbUQSwCaKNRXLbRE60mMholmGzPZNf38fvwPkgXhYCgTDYGSbZLxhnKBQhhQzaiZLu8EPKsAEqrlVV63I4nHv2+frPigUgZ0yeODsfX86lPE6k5RFUhiURTT47IkGVEqJVKqq3te+oASHSrABUgW6iEVEVNAMCkgQPXEKMmdAfFT7/748JHjLfft8fn20CdshR+MCsIgKUCoaMQ9oWmWFJVAhKobpWnhpCmEIZSh68Bnnc6f7+NHGzx/fx/WlVltdOCMpZjDdjt0pE3RSuve+EEQAVCNcaFEAJFtIlCpRSvXgwUgg1DR1onwAq6Rki6LK8TlszysnKrtDMCACqtABarQFrRoa4EsJw2AQKbMCj6+cV/Sg+oJRQCumsRT4khWMJoTSwd0WJBGLidmjEIjKvICxymtpE4ZKbCLbpJRLKQYlyTHGYQFMCsmVEqQBeHKoT5ARCb/EBhBAQzIIsNQRnM5hQAEQACGAbAVAysfLg+dAgnVboopEQKmDQSsJgl9jr6JwJKtAGVe2rxWai9wBJpyJOI7qM5oYjmYZXKiL4M/ch6en96xvcP2fH468fdM6E4SiEXayARgBBRtg4yVxhS4hvIaSaEQYQHHYEuMBLAEB/3af8AWft4A7zx6P1nSIw5OuPNTAMlGe9QgGmDZUbUMBFU+XQpjasEuDTMYhAtyI2YAbizaJZF+3r8aM4njCxZz78Pzz/vrk0HsZMVKsCiYxDbDpNobsaSTNRCGU0Fi3T6Rx+/t22IrkaUf9DrTqW+ASryFI/VzS3MARPCRYBDw6P6HRiq1EGDGe0JQHRDXygfp+Pxt/69HP8AfWZ2NiqKMoLy53pqbVEDUo/BJNgnUbQRyIOxg3EEqJI1I8ba/YcfbH221x/ZydYUZcwBB8NsCJcs7nmmZWWmSgoRawB2AABABQAUAUBjYoDh+5yaM5hsUcmPR4frjSNgMdWDRCQsGFeL6AxqlVZVV77UoNlJDoGjYKFGg+FMAgIE8JEpSJ92heJx79tsTiZ9u/x+Oqksj5QcFVpCUgCXSMbsiZiaIAGCk8Vq3aSZFQX2QByrBy6lHsW7TKYVAVFhdF0IS9shQMJQlwFTeKMmdBM4Z/v52QNONfDl6en9eQyeFrnTydv799jq9avFvD9c+QzDwNf6IX+tjg5WuaPx9/78iVynsbNKoI/c1+zUfnUnJqmnGsAnZx8dvx7ajHA/xz//2gAIAQMDAT8Q/wAcwCHGhXc1LoDC6CwuhYzqvG/IhWK1RRlsoLfy0DKk8hgNFKKOxisaDiPIdoY7Wk+Ws2Y3grBnTLxiAKOG5DkRCQmSZD2kb938HxtYECCAkd2YA4gaaXCJrEMazYUhThSWPaWO71TgfP8Ae2ifx/X53BKFmlyqtAFQEoBdH+2Gckj3AuQOIJHN86zXEWJVSkrKJyaEQTCSez4sB+1oCEPCgGCAAMum8EihsowgcEr1VBIcbWCrA6EhtoJ9GUBg4gFbHGgeDNGdLrW/JBDEKRLKRpbbuoSyVQjZqThPCWznEISkRYTAs6anOWYlT+AMAAAAAdWxWG2qcthUTSkBAzUqKGDYfZMYImWIBGwBFSMDAIfSKk9oBQqwJZUEtGkeeFC5RwAq8A6BMdZQpheGQlZXHOsVDDtqnDwR1xQSsrhSqjSh0m5fgBuNzGAqGUDdG7AvaADnloHEp60HM0FSybESMGf68FT1SM0oCSGeSAqSdrVDPCClCKNsiARPz8Aieo4tWgAwAdbk7nP16eIKwZ0MTVexISBGABWRZKgGjBDAEABAAYArank7gAoNACq0BLpv0zP6wMQ4KhFJZutoJDjTucceEPe4/v5+s6XIRqEIEqBKkqgFqBOuOJOapFNhAIskm3azrLyFc8spckABAddwGGNOfYvQAQUGjAWEkXUyvFjFBNsYp9sLgRimNkGGI0yY45RLWA4BAAAADr5IjnTEQAWJxwEORFZoJ+3CgcNwAA7G1yoEqtAFqvY0o0liVbj5TtVRBt18WZ3KsAFqIAWrGgMTQ4eAJmKbhixXdPxNLKcoyIJ6ClDyAZCqAoGIGkvazktuJOskhqAwxwAxqItSsHe4JoCsGJz2R5AH5iAzS2EFJAk9To6qMQCAuVe6qqVVV3SSGpQ4lVchIgxwqMuXr4AFTAGV1jB5rTGaCiqSRuhHakrwhtJ7vieA8EaywY/vXu5151VBYgglG2YKhRRW1sRKgya9fSSAmUBSSU6MrgT1Q4XATeqDl/HgvYaESTHXCai9ijexpgk4EEVhJ1LyoCUhrTzu4TelMFJCgKkZmIaJljSIs+PI+OuR9lcQnNqx9hEiW6Bd1Y32UymWrKVngztNgqkyaMh1p4dBAmH6FozmUlM525U/EFhUyDGnUi3TCRCNWul8OWCS0HRT8msVzsqnLrMbec0SuEKGXhhHUOZJcm/d+KhYAA2vbvEVUZGbo0MqDZKpltq3DrDVs9AhnKyBf4WG4M0NrwjcAYuIcCROrZVtVyryuw2WkVDnY8TQiSY6saomLUIzdmkRhJAgAgo2wOpAEKxlkqMEgAqIDwRHlkZzCxLCOJhtkI5M/XptgZY46rhdDkSkRISUALWNA3irIgXKFAWWZtnxAABD4xzGfszXsBLxqLcIQm7jCdlIIUaFW3woDEhUTAKYROD/AMGo9m2FDj9T5DCZjTEYd9gqhnRDyGARhq0t/LYKpo6oWvIi/S9CynSWR1D4IVY76EEmP8c//9k='
var BLUR_DATA = "data:image/png;base64,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";
var S3_PROPERTY_BUCKET_URL = "https://".concat("dxbstay-media-prod", ".s3.amazonaws.com");
var S3_USER_BUCKET_URL = "https://".concat("dxbstay-user-media-prod", ".s3.amazonaws.com");
var S3_SITE_MEDIA_BUCKET_URL = "https://".concat("dxbstay-site-carousal-prod", ".s3.amazonaws.com");
var MAX_FILE_SIZE_BYTES = 3000000; //3MB
var allowMimeTypes = (/* unused pure expression or super */ null && ([
    "image/png",
    "image/svg+xml",
    "image/gif",
    "image/jpeg",
    "image/webp", 
]));
function isImage(mimeType) {
    return allowMimeTypes.indexOf(mimeType) > -1;
}
function decodeToken(token) {
    return (0,jwt_decode__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(token);
}
/*export function generateKey(token, type, fileName) {

	const tokenData = decodeToken(token);

	const extension = fileName.split(".")[1];

	return `${tokenData?.userId}_${type}_${generateId()}.${extension.toLowerCase()}`

}*/ function generateId() {
    var result = "";
    var characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!-.*()";
    var length = 10;
    var charactersLength = characters.length;
    for(var i = 0; i < length; i += 1){
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    var date = new Date().toISOString().split("T")[0].replace(/-/g, "");
    return "".concat(date, "_").concat(result);
}
function bytesToMb(bytes) {
    return bytes / 1000000;
}
function returnFileSize(number) {
    if (number < 1024) {
        return "".concat(number, "bytes");
    } else if (number >= 1024 && number < 1048576) {
        return "".concat((number / 1024).toFixed(1), "KB");
    } else if (number >= 1048576) {
        return "".concat((number / 1048576).toFixed(1), "MB");
    }
}
var checkFileSizeIsInLimit = function(file) {
    return bytesToMb(file.size) <= bytesToMb(MAX_FILE_SIZE_BYTES);
};
var checkFileIsAImage = function(file) {
    var ref = _sliced_to_array(file.type.split("/"), 1), type = ref[0];
    return !(!type || type !== "image");
};
function generateKey() {
    var result = "";
    var characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!-.*()";
    var length = 10;
    var charactersLength = characters.length;
    for(var i = 0; i < length; i += 1){
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return "".concat(result);
}


/***/ }),

/***/ 85992:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(828);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _mantine_hooks__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5686);
/* harmony import */ var next_auth_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(33299);
/* harmony import */ var next_auth_react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_auth_react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_network_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41448);
/* harmony import */ var _features_common_hooks_use_user_profile_status__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10547);






/**
 * SINGLE SOURCE OF TRUTH FOR USER INITIAL DATA
 * DONT MIX IT WITH PROFILE DATA
 * */ function useUserData() {
    var session = (0,next_auth_react__WEBPACK_IMPORTED_MODULE_1__.useSession)();
    var fetchUserStatus = (0,_features_common_hooks_use_user_profile_status__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)().fetchUserStatus;
    /**
     * Check if User is logged in and have active session.
     *
     * isUser();
     * */ var isUser = function() {
        var ref;
        return !!(session === null || session === void 0 ? void 0 : (ref = session.data) === null || ref === void 0 ? void 0 : ref.user);
    };
    var getUserId = function() {
        if (isUser()) {
            var ref, ref1;
            // @ts-expect-error
            return (0,_utils_network_utils__WEBPACK_IMPORTED_MODULE_2__/* .decodeToken */ .TD)(session === null || session === void 0 ? void 0 : (ref = session.data) === null || ref === void 0 ? void 0 : (ref1 = ref.user) === null || ref1 === void 0 ? void 0 : ref1.accessToken).userId;
        } else {
            return -1;
        }
    };
    var getUserEmail = function() {
        if (isUser()) {
            var ref;
            return session === null || session === void 0 ? void 0 : (ref = session.data) === null || ref === void 0 ? void 0 : ref.user.email;
        } else {
            return null;
        }
    };
    // TODO: TYPINGS FOR PROP IDS
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_mantine_hooks__WEBPACK_IMPORTED_MODULE_5__/* .useLocalStorage */ ._)({
        key: "user-prop-ids"
    }), 2), userPropIds = ref[0], _setUserPropIds = ref[1];
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_mantine_hooks__WEBPACK_IMPORTED_MODULE_5__/* .useLocalStorage */ ._)({
        key: "user-profile",
        defaultValue: {
            name: "__",
            email: "no-reply@dxbstay.com",
            image: null,
            country: null,
            phone: null,
            profileStatus: null,
            accountStatus: null
        }
    }), 2), userProfileData = ref1[0], _setUserProfileData = ref1[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (isUser()) {
            var ref;
            var _user = session === null || session === void 0 ? void 0 : (ref = session.data) === null || ref === void 0 ? void 0 : ref.user;
            // WHEN EVER THE USER LOGS IN IT WILL GET THE DATA
            _setUserProfileData({
                name: _user.name,
                image: _user.image,
                email: _user.email,
                profileStatus: _user.profile_status,
                accountStatus: _user.account_status
            });
        }
    }, [
        session
    ]);
    var getUserProfileData = function() {
        return userProfileData;
    };
    var setUserProfileData = function(data) {
        _setUserProfileData(data);
    };
    var clearUserProfileData = function() {
        _setUserProfileData({
            name: "",
            email: "",
            image: null,
            userId: -1,
            profileStatus: null,
            accountStatus: null
        });
    };
    var getUserPropIds = function() {
        return userPropIds;
    };
    var setUserPropIds = function(data) {
        _setUserPropIds(data);
    };
    var isPassportApproved = function() {
        return fetchUserStatus(getUserEmail()).then(function(res) {
            if (res.status) {
                return Promise.resolve(res.result);
            } else {
                return Promise.resolve(false);
            }
        }).catch(function(err) {
            console.error(err);
            return Promise.resolve(false);
        });
    };
    var clearUserPropIds = function() {
        _setUserPropIds(null);
    };
    return {
        isUser: isUser,
        isPassportApproved: isPassportApproved,
        getUserId: getUserId,
        getUserEmail: getUserEmail,
        getUserPropIds: getUserPropIds,
        getUserProfileData: getUserProfileData,
        setUserProfileData: setUserProfileData,
        clearUserProfileData: clearUserProfileData,
        clearUserPropIds: clearUserPropIds,
        setUserPropIds: setUserPropIds
    };
}
/* harmony default export */ __webpack_exports__["Z"] = (useUserData);


/***/ }),

/***/ 10547:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ use_user_profile_status; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./src/core/hooks/useNotification.ts
var useNotification = __webpack_require__(96682);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@tabler/icons/icons-react/dist/index.esm.js
var index_esm = __webpack_require__(63991);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Group/Group.js + 1 modules
var Group = __webpack_require__(71232);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Text/Text.js + 1 modules
var Text = __webpack_require__(95117);
// EXTERNAL MODULE: ./node_modules/@mantine/next/esm/NextLink.js
var NextLink = __webpack_require__(8798);
// EXTERNAL MODULE: ./src/core/router/AppRoutes.ts
var AppRoutes = __webpack_require__(84396);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/core/hooks/notification-utils.tsx






var ProfileStatusNotificationData = {
    "passport_not_found": {
        title: "Please complete your profile.",
        color: "blue",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* IconAlertCircle */.Ldj, {
            size: 16
        }),
        message: /*#__PURE__*/ (0,jsx_runtime.jsx)(Group/* Group */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                variant: "link",
                component: NextLink/* NextLink */.p,
                href: AppRoutes/* AppRoutes.ACCOUNT */.$w.ACCOUNT,
                children: "Update Passport Image"
            })
        })
    },
    "passport_pending": {
        title: "Profile Status",
        color: "green",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* IconAlertCircle */.Ldj, {
            size: 16
        }),
        message: /*#__PURE__*/ (0,jsx_runtime.jsx)(Group/* Group */.Z, {
            children: "Thank you for providing us with your passport copy, it is in approval process."
        })
    },
    "passport_rejected": {
        title: "Action required",
        color: "orange",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* IconAlertCircle */.Ldj, {
            size: 16
        }),
        message: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
            children: [
                "Rejected due to validity of the Passport; Please upload a valid passport.",
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                    variant: "link",
                    component: NextLink/* NextLink */.p,
                    href: AppRoutes/* AppRoutes.ACCOUNT */.$w.ACCOUNT,
                    children: "Update Passport"
                })
            ]
        })
    }
};

// EXTERNAL MODULE: ./src/generated/graphql.tsx
var graphql = __webpack_require__(89402);
;// CONCATENATED MODULE: ./src/features/common/hooks/use-user-profile-status.ts




var useUserProfileStatus = function() {
    var ref = (0,useNotification/* default */.Z)(), notify = ref.notify, showUserProfileStatusNotification = ref.showUserProfileStatusNotification;
    //<editor-fold desc="GET USER STATUS CALL">
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,graphql/* useGetUserStatusLazyQuery */.kq)({
        fetchPolicy: "network-only"
    }), 1), GetUserStatus = ref1[0];
    var fetchUserStatus = function(_email) {
        // if(!_email) return ;
        // SEND SERVER CALL
        return GetUserStatus({
            variables: {
                email: _email
            }
        }).then(function(res) {
            var ref;
            // console.log(res, "res")
            var userStatus = res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : ref.getUserStatus;
            // ONLY WHEN THE STATUS IS NOT APPROVED
            if (userStatus.profile_status !== graphql/* RecordStatus.PassportApproved */.rf.PassportApproved) {
                var notificationConfigs = ProfileStatusNotificationData[userStatus.profile_status];
                showUserProfileStatusNotification(notificationConfigs.title, notificationConfigs.message, notificationConfigs.color, notificationConfigs.icon);
            }
            return Promise.resolve({
                result: userStatus.profile_status === graphql/* RecordStatus.PassportApproved */.rf.PassportApproved,
                status: true
            });
        }).catch(function(err) {
            console.error(err);
            notify(useNotification/* NotificationType.ERROR */.k.ERROR, "Oops we broke something!", 2000);
            return Promise.resolve({
                result: null,
                status: false
            });
        });
    };
    //</editor-fold>
    return {
        fetchUserStatus: fetchUserStatus
    };
};
/* harmony default export */ var use_user_profile_status = (useUserProfileStatus);


/***/ }),

/***/ 89402:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$h": function() { return /* binding */ useChangePasswordMutation; },
/* harmony export */   "A6": function() { return /* binding */ useCreateNewPassportMutation; },
/* harmony export */   "BW": function() { return /* binding */ useSearchPropertiesQuery; },
/* harmony export */   "Bz": function() { return /* binding */ useGetPricesQuery; },
/* harmony export */   "KM": function() { return /* binding */ useGetUserFavPropIdsLazyQuery; },
/* harmony export */   "LF": function() { return /* binding */ useUpdateUserProfileMutation; },
/* harmony export */   "OH": function() { return /* binding */ useCancelSmoobuDxbBookingMutation; },
/* harmony export */   "Pe": function() { return /* binding */ useCreateBookingPaymentSessionMutation; },
/* harmony export */   "Rx": function() { return /* binding */ useSendInquiryEmailMutation; },
/* harmony export */   "UX": function() { return /* binding */ useGetUserStatusQuery; },
/* harmony export */   "U_": function() { return /* binding */ useRegisterUserMutation; },
/* harmony export */   "Vj": function() { return /* binding */ useGetUserFavPropertiesQuery; },
/* harmony export */   "X8": function() { return /* binding */ useGetUserProfileLazyQuery; },
/* harmony export */   "Xr": function() { return /* binding */ useGetUserBookingsQuery; },
/* harmony export */   "aq": function() { return /* binding */ useSaveUserFavPropertyMutation; },
/* harmony export */   "d1": function() { return /* binding */ useGetSearchLocationsQuery; },
/* harmony export */   "gL": function() { return /* binding */ useResetPasswordMutation; },
/* harmony export */   "ju": function() { return /* binding */ useRemoveUserFavPropertyMutation; },
/* harmony export */   "kq": function() { return /* binding */ useGetUserStatusLazyQuery; },
/* harmony export */   "lq": function() { return /* binding */ useUpdateUserAvatarMutation; },
/* harmony export */   "o5": function() { return /* binding */ useResendConfirmEmailMutation; },
/* harmony export */   "pn": function() { return /* binding */ useGetUserProfileQuery; },
/* harmony export */   "rf": function() { return /* binding */ RecordStatus; },
/* harmony export */   "xy": function() { return /* binding */ useForgetPasswordMutation; },
/* harmony export */   "xz": function() { return /* binding */ useGetMaxGuestCountQuery; },
/* harmony export */   "z5": function() { return /* binding */ useGetServiceKeysQuery; }
/* harmony export */ });
/* unused harmony exports AuthMethod, CacheControlScope, Gender, Status, AuthenticateDocument, useAuthenticateMutation, CancelSmoobuDxbBookingDocument, ChangePasswordDocument, SendInquiryEmailDocument, CreateBookingPaymentSessionDocument, ForgetPasswordDocument, GetAllCarousalSlidesDocument, useGetAllCarousalSlidesQuery, useGetAllCarousalSlidesLazyQuery, GetFeaturedPropertiesDocument, useGetFeaturedPropertiesQuery, useGetFeaturedPropertiesLazyQuery, GetMaxGuestCountDocument, useGetMaxGuestCountLazyQuery, GetPricesDocument, useGetPricesLazyQuery, GetPropertiesDocument, useGetPropertiesQuery, useGetPropertiesLazyQuery, GetPropertyBySlugDocument, useGetPropertyBySlugQuery, useGetPropertyBySlugLazyQuery, GetPropertyByIdDocument, useGetPropertyByIdQuery, useGetPropertyByIdLazyQuery, GetAllSettingsDocument, useGetAllSettingsQuery, useGetAllSettingsLazyQuery, GetSearchLocationsDocument, useGetSearchLocationsLazyQuery, GetServiceKeysDocument, useGetServiceKeysLazyQuery, GetUserBookingsDocument, useGetUserBookingsLazyQuery, GetUserFavPropIdsDocument, useGetUserFavPropIdsQuery, GetUserFavPropertiesDocument, useGetUserFavPropertiesLazyQuery, GetUserProfileDocument, GetUserStatusDocument, RegisterUserDocument, RemoveUserFavPropertyDocument, ResendConfirmEmailDocument, ResetPasswordDocument, SaveUserFavPropertyDocument, SearchPropertiesDocument, useSearchPropertiesLazyQuery, CreateNewPassportDocument, UpdateUserAvatarDocument, UpdateUserProfileDocument */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17283);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50319);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(37887);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(73359);
// THIS IS A GENERATED FILE, use `yarn codegen` to regenerate
/* tslint:disable */ 

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation authenticate($input: AuthInput!) {\n        authenticate(input: $input) {\n            status\n            data\n            error\n        }\n    }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation CancelSmoobuDxbBooking($input: CancelBookingInput!) {\n        cancelSmoobuDxbBooking(input: $input) {\n            data\n            error\n            status\n        }\n    }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation ChangePassword($input: ChangePasswordInput!) {\n        changePassword(input: $input) {\n            data\n            error\n            status\n        }\n    }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation sendInquiryEmail($input: InquiryInput!) {\n        sendInquiryEmail(input: $input) {\n            data\n            error\n            status\n        }\n    }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation CreateBookingPaymentSession($input: CreateBookingPaymentInput!) {\n        createBookingPaymentSession(input: $input) {\n            data\n            error\n            status\n        }\n    }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation ForgetPassword($input: ForgetPasswordInput!) {\n        forgetPassword(input: $input) {\n            data\n            error\n            status\n        }\n    }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    query GetAllCarousalSlides {\n        getAllCarousalSlides {\n            id\n            title\n            heading\n            description\n            background_image_url\n            target_url\n            status\n        }\n    }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    query GetFeaturedProperties {\n        getFeaturedProperties {\n            id\n            parent_id\n            smoobu_id\n            name\n            description\n            details {\n                max_occupancy\n                bed_rooms\n                bath_rooms\n                size\n            }\n            images {\n                status\n                src\n                type\n            }\n            location {\n                address\n                city\n                country\n                state\n                street\n            }\n            settings {\n                status\n                sort_order\n                is_featured\n                slug\n                minimumNights\n            }\n            priceDetails {\n                pricePerNight\n            }\n        }\n    }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    query GetMaxGuestCount {\n        getMaxGuestCount {\n            max\n        }\n    }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    query GetPrices($propertyId: ID!, $smoobuId: ID!) {\n        getPrices(propertyId: $propertyId, smoobuId: $smoobuId) {\n            dxbstay {\n                amount\n                priceType {\n                    name\n                    condition\n                    conditional\n                }\n            }\n            smoobu {\n                available\n                blocked\n                date\n                min_length_of_stay\n                price\n            }\n        }\n    }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    query GetProperties {\n        getProperties {\n            id\n            parent_id\n            smoobu_id\n            name\n            description\n            details {\n                size\n                max_occupancy\n                bath_rooms\n                bed_rooms\n                child_beds\n                couches\n                double_beds\n                king_size_beds\n                queen_size_beds\n                single_beds\n                sofa_beds\n                amenities\n                type\n            }\n            images {\n                id\n                position\n                title\n                type\n                src\n                alt\n                width\n                height\n                status\n            }\n            location {\n                street\n                zip\n                state\n                longitude\n                latitude\n                description\n                country\n                city\n                address\n                keywords\n            }\n            settings {\n                time_zone\n                status\n                sort_order\n                map\n                is_featured\n                slug\n                calendarState\n                minimumNights\n            }\n            priceDetails {\n                pricePerNight\n            }\n        }\n    }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    query GetPropertyBySlug($slug: String!) {\n        getPropertyBySlug(slug: $slug) {\n            id\n            parent_id\n            smoobu_id\n            name\n            description\n            details {\n                bath_rooms\n                amenities\n                bed_rooms\n                child_beds\n                couches\n                king_size_beds\n                double_beds\n                max_occupancy\n                queen_size_beds\n                single_beds\n                size\n                sofa_beds\n                type\n            }\n            images {\n                id\n                position\n                title\n                type\n                src\n                alt\n                width\n                height\n                status\n            }\n            location {\n                zip\n                street\n                state\n                longitude\n                latitude\n                id\n                description\n                country\n                city\n                address\n                keywords\n            }\n            priceDetails {\n                pricePerNight\n            }\n            settings {\n                time_zone\n                status\n                sort_order\n                map\n                slug\n                is_featured\n                calendarState\n                minimumNights\n            }\n        }\n    }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    query GetPropertyById($propertyId: ID!) {\n        getPropertyById(propertyId: $propertyId) {\n            id\n            parent_id\n            smoobu_id\n            name\n            description\n            details {\n                bath_rooms\n                amenities\n                bed_rooms\n                child_beds\n                couches\n                king_size_beds\n                double_beds\n                max_occupancy\n                queen_size_beds\n                single_beds\n                size\n                sofa_beds\n                type\n            }\n            images {\n                id\n                position\n                title\n                type\n                src\n                alt\n                width\n                height\n                status\n            }\n            location {\n                zip\n                street\n                state\n                longitude\n                latitude\n                id\n                description\n                country\n                city\n                address\n            }\n            priceDetails {\n                pricePerNight\n            }\n            settings {\n                time_zone\n                status\n                sort_order\n                map\n                is_featured\n                slug\n                calendarState\n                minimumNights\n            }\n        }\n    }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    query GetAllSettings {\n        getAllSettings {\n            slug\n        }\n    }\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    query GetSearchLocations {\n        getSearchLocations {\n            id\n            zip\n            state\n            keywords\n            street\n            city\n            address\n            description\n            country\n            latitude\n            longitude\n        }\n    }\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    query GetServiceKeys {\n        getServiceKeys {\n            name\n            value\n            status\n        }\n    }\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    query GetUserBookings($userId: ID!) {\n        getUserBookings(userId: $userId) {\n            id\n            reservation_id\n            start_date\n            end_date\n            status\n            guests\n            dxb_stay_price_ids\n            price_per_night\n            total_nights\n            total_price\n            grand_total_price\n            property {\n                id\n                smoobu_id\n                name\n                description\n                details {\n                    bath_rooms\n                    bed_rooms\n                }\n                images {\n                    type\n                    src\n                }\n                location {\n                    address\n                }\n                prices {\n                    priceType {\n                        name\n                    }\n                    amount\n                }\n            }\n        }\n    }\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    query GetUserFavPropIds($userId: ID!) {\n        getUserFavPropIds(userId: $userId) {\n            property_id\n        }\n    }\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    query GetUserFavProperties($email: String!) {\n        getUserFavProperties(email: $email) {\n            id\n            parent_id\n            smoobu_id\n            name\n            description\n            details {\n                amenities\n                bath_rooms\n                bed_rooms\n                child_beds\n                couches\n                double_beds\n                king_size_beds\n                max_occupancy\n                queen_size_beds\n                single_beds\n                size\n                sofa_beds\n                type\n            }\n            images {\n                id\n                position\n                title\n                type\n                src\n                alt\n                width\n                height\n                status\n            }\n            location {\n                zip\n                street\n                state\n                longitude\n                latitude\n                keywords\n                id\n                description\n                country\n                city\n                address\n            }\n            priceDetails {\n                pricePerNight\n            }\n            settings {\n                time_zone\n                status\n                sort_order\n                slug\n                map\n                is_featured\n                calendarState\n                minimumNights\n            }\n        }\n    }\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    query GetUserProfile($email: String!) {\n        getUserProfile(email: $email) {\n            id\n            country\n            email\n            image\n            name\n            first_name\n            last_name\n            phone\n            profile_status\n            status\n            passport {\n                image\n            }\n        }\n    }\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    query GetUserStatus($email: String!) {\n        getUserStatus(email: $email) {\n            profile_status\n            status\n        }\n    }\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation registerUser($input: CreateUserInput!) {\n        registerUser(input: $input) {\n            status\n            data\n            error\n        }\n    }\n"
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation RemoveUserFavProperty($propertyId: ID!, $userId: ID!) {\n        removeUserFavProperty(propertyId: $propertyId, userId: $userId) {\n            data\n            error\n            status\n        }\n    }\n"
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation ResendConfirmEmail($input: ResendConfirmEmailInput!) {\n        resendConfirmEmail(input: $input) {\n            data\n            error\n            status\n        }\n    }\n"
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation ResetPassword($input: ResetPasswordInput!) {\n        resetPassword(input: $input) {\n            data\n            error\n            status\n        }\n    }\n"
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation SaveUserFavProperty($propertyId: ID!, $userId: ID!) {\n        saveUserFavProperty(propertyId: $propertyId, userId: $userId) {\n            data\n            error\n            status\n        }\n    }\n"
    ]);
    _templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    query SearchProperties($input: PropertySearchInput!) {\n        searchProperties(input: $input) {\n            id\n            parent_id\n            smoobu_id\n            name\n            bath_rooms\n            bed_rooms\n            max_occupancy\n            thumb\n            name\n            street\n            country\n            city\n            address\n            pricePerNight\n            sort_order\n            map\n            slug\n            is_featured\n            keywords\n            settings {\n                minimumNights\n            }\n            details {\n                size\n            }\n        }\n    }\n"
    ]);
    _templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}
function _templateObject27() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation CreateNewPassport($input: CreatePassportInput!) {\n        createNewPassport(input: $input) {\n            data\n            error\n            status\n        }\n    }\n"
    ]);
    _templateObject27 = function _templateObject27() {
        return data;
    };
    return data;
}
function _templateObject28() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation UpdateUserAvatar($userId: ID!, $image: String!) {\n        updateUserAvatar(userId: $userId, image: $image) {\n            data\n            error\n            status\n        }\n    }\n"
    ]);
    _templateObject28 = function _templateObject28() {
        return data;
    };
    return data;
}
function _templateObject29() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    mutation UpdateUserProfile($input: UpdateUserProfileInput!) {\n        updateUserProfile(input: $input) {\n            data\n            status\n            error\n        }\n    }\n"
    ]);
    _templateObject29 = function _templateObject29() {
        return data;
    };
    return data;
}


var defaultOptions = {};
var AuthMethod;
(function(AuthMethod) {
    AuthMethod["Both"] = "BOTH";
    AuthMethod["EmailOnly"] = "EMAIL_ONLY";
    AuthMethod["NotSecure"] = "NOT_SECURE";
    AuthMethod["SmsOnly"] = "SMS_ONLY";
})(AuthMethod || (AuthMethod = {}));
var CacheControlScope;
(function(CacheControlScope) {
    CacheControlScope["Private"] = "PRIVATE";
    CacheControlScope["Public"] = "PUBLIC";
})(CacheControlScope || (CacheControlScope = {}));
var Gender;
(function(Gender) {
    Gender["Female"] = "FEMALE";
    Gender["Male"] = "MALE";
    Gender["Unknown"] = "UNKNOWN";
})(Gender || (Gender = {}));
var RecordStatus;
(function(RecordStatus) {
    RecordStatus["Banned"] = "banned";
    RecordStatus["Disabled"] = "disabled";
    RecordStatus["Enabled"] = "enabled";
    RecordStatus["Hold"] = "hold";
    RecordStatus["PassportApproved"] = "passport_approved";
    RecordStatus["PassportNotFound"] = "passport_not_found";
    RecordStatus["PassportPending"] = "passport_pending";
    RecordStatus["PassportRejected"] = "passport_rejected";
    RecordStatus["Pending"] = "pending";
    RecordStatus["Resume"] = "resume";
    RecordStatus["Suspended"] = "suspended";
    RecordStatus["Verified"] = "verified";
})(RecordStatus || (RecordStatus = {}));
var Status;
(function(Status) {
    Status["Error"] = "ERROR";
    Status["Failed"] = "FAILED";
    Status["Success"] = "SUCCESS";
})(Status || (Status = {}));
var AuthenticateDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject());
/**
 * __useAuthenticateMutation__
 *
 * To run a mutation, you first call `useAuthenticateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthenticateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authenticateMutation, { data, loading, error }] = useAuthenticateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */ function useAuthenticateMutation(baseOptions) {
    var options = _object_spread({}, defaultOptions, baseOptions);
    return Apollo.useMutation(AuthenticateDocument, options);
}
var CancelSmoobuDxbBookingDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject1());
/**
 * __useCancelSmoobuDxbBookingMutation__
 *
 * To run a mutation, you first call `useCancelSmoobuDxbBookingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelSmoobuDxbBookingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelSmoobuDxbBookingMutation, { data, loading, error }] = useCancelSmoobuDxbBookingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */ function useCancelSmoobuDxbBookingMutation(baseOptions) {
    var options = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, defaultOptions, baseOptions);
    return _apollo_client__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .D(CancelSmoobuDxbBookingDocument, options);
}
var ChangePasswordDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject2());
/**
 * __useChangePasswordMutation__
 *
 * To run a mutation, you first call `useChangePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changePasswordMutation, { data, loading, error }] = useChangePasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */ function useChangePasswordMutation(baseOptions) {
    var options = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, defaultOptions, baseOptions);
    return _apollo_client__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .D(ChangePasswordDocument, options);
}
var SendInquiryEmailDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject3());
/**
 * __useSendInquiryEmailMutation__
 *
 * To run a mutation, you first call `useSendInquiryEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendInquiryEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendInquiryEmailMutation, { data, loading, error }] = useSendInquiryEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */ function useSendInquiryEmailMutation(baseOptions) {
    var options = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, defaultOptions, baseOptions);
    return _apollo_client__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .D(SendInquiryEmailDocument, options);
}
var CreateBookingPaymentSessionDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject4());
/**
 * __useCreateBookingPaymentSessionMutation__
 *
 * To run a mutation, you first call `useCreateBookingPaymentSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBookingPaymentSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBookingPaymentSessionMutation, { data, loading, error }] = useCreateBookingPaymentSessionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */ function useCreateBookingPaymentSessionMutation(baseOptions) {
    var options = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, defaultOptions, baseOptions);
    return _apollo_client__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .D(CreateBookingPaymentSessionDocument, options);
}
var ForgetPasswordDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject5());
/**
 * __useForgetPasswordMutation__
 *
 * To run a mutation, you first call `useForgetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useForgetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [forgetPasswordMutation, { data, loading, error }] = useForgetPasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */ function useForgetPasswordMutation(baseOptions) {
    var options = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, defaultOptions, baseOptions);
    return _apollo_client__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .D(ForgetPasswordDocument, options);
}
var GetAllCarousalSlidesDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject6());
/**
 * __useGetAllCarousalSlidesQuery__
 *
 * To run a query within a React component, call `useGetAllCarousalSlidesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllCarousalSlidesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllCarousalSlidesQuery({
 *   variables: {
 *   },
 * });
 */ function useGetAllCarousalSlidesQuery(baseOptions) {
    var options = _object_spread({}, defaultOptions, baseOptions);
    return Apollo.useQuery(GetAllCarousalSlidesDocument, options);
}
function useGetAllCarousalSlidesLazyQuery(baseOptions) {
    var options = _object_spread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(GetAllCarousalSlidesDocument, options);
}
var GetFeaturedPropertiesDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject7());
/**
 * __useGetFeaturedPropertiesQuery__
 *
 * To run a query within a React component, call `useGetFeaturedPropertiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeaturedPropertiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeaturedPropertiesQuery({
 *   variables: {
 *   },
 * });
 */ function useGetFeaturedPropertiesQuery(baseOptions) {
    var options = _object_spread({}, defaultOptions, baseOptions);
    return Apollo.useQuery(GetFeaturedPropertiesDocument, options);
}
function useGetFeaturedPropertiesLazyQuery(baseOptions) {
    var options = _object_spread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(GetFeaturedPropertiesDocument, options);
}
var GetMaxGuestCountDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject8());
/**
 * __useGetMaxGuestCountQuery__
 *
 * To run a query within a React component, call `useGetMaxGuestCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMaxGuestCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMaxGuestCountQuery({
 *   variables: {
 *   },
 * });
 */ function useGetMaxGuestCountQuery(baseOptions) {
    var options = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, defaultOptions, baseOptions);
    return _apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .useQuery */ .a(GetMaxGuestCountDocument, options);
}
function useGetMaxGuestCountLazyQuery(baseOptions) {
    var options = _object_spread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(GetMaxGuestCountDocument, options);
}
var GetPricesDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject9());
/**
 * __useGetPricesQuery__
 *
 * To run a query within a React component, call `useGetPricesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPricesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPricesQuery({
 *   variables: {
 *      propertyId: // value for 'propertyId'
 *      smoobuId: // value for 'smoobuId'
 *   },
 * });
 */ function useGetPricesQuery(baseOptions) {
    var options = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, defaultOptions, baseOptions);
    return _apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .useQuery */ .a(GetPricesDocument, options);
}
function useGetPricesLazyQuery(baseOptions) {
    var options = _object_spread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(GetPricesDocument, options);
}
var GetPropertiesDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject10());
/**
 * __useGetPropertiesQuery__
 *
 * To run a query within a React component, call `useGetPropertiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPropertiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPropertiesQuery({
 *   variables: {
 *   },
 * });
 */ function useGetPropertiesQuery(baseOptions) {
    var options = _object_spread({}, defaultOptions, baseOptions);
    return Apollo.useQuery(GetPropertiesDocument, options);
}
function useGetPropertiesLazyQuery(baseOptions) {
    var options = _object_spread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(GetPropertiesDocument, options);
}
var GetPropertyBySlugDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject11());
/**
 * __useGetPropertyBySlugQuery__
 *
 * To run a query within a React component, call `useGetPropertyBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPropertyBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPropertyBySlugQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */ function useGetPropertyBySlugQuery(baseOptions) {
    var options = _object_spread({}, defaultOptions, baseOptions);
    return Apollo.useQuery(GetPropertyBySlugDocument, options);
}
function useGetPropertyBySlugLazyQuery(baseOptions) {
    var options = _object_spread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(GetPropertyBySlugDocument, options);
}
var GetPropertyByIdDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject12());
/**
 * __useGetPropertyByIdQuery__
 *
 * To run a query within a React component, call `useGetPropertyByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPropertyByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPropertyByIdQuery({
 *   variables: {
 *      propertyId: // value for 'propertyId'
 *   },
 * });
 */ function useGetPropertyByIdQuery(baseOptions) {
    var options = _object_spread({}, defaultOptions, baseOptions);
    return Apollo.useQuery(GetPropertyByIdDocument, options);
}
function useGetPropertyByIdLazyQuery(baseOptions) {
    var options = _object_spread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(GetPropertyByIdDocument, options);
}
var GetAllSettingsDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject13());
/**
 * __useGetAllSettingsQuery__
 *
 * To run a query within a React component, call `useGetAllSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllSettingsQuery({
 *   variables: {
 *   },
 * });
 */ function useGetAllSettingsQuery(baseOptions) {
    var options = _object_spread({}, defaultOptions, baseOptions);
    return Apollo.useQuery(GetAllSettingsDocument, options);
}
function useGetAllSettingsLazyQuery(baseOptions) {
    var options = _object_spread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(GetAllSettingsDocument, options);
}
var GetSearchLocationsDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject14());
/**
 * __useGetSearchLocationsQuery__
 *
 * To run a query within a React component, call `useGetSearchLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSearchLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSearchLocationsQuery({
 *   variables: {
 *   },
 * });
 */ function useGetSearchLocationsQuery(baseOptions) {
    var options = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, defaultOptions, baseOptions);
    return _apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .useQuery */ .a(GetSearchLocationsDocument, options);
}
function useGetSearchLocationsLazyQuery(baseOptions) {
    var options = _object_spread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(GetSearchLocationsDocument, options);
}
var GetServiceKeysDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject15());
/**
 * __useGetServiceKeysQuery__
 *
 * To run a query within a React component, call `useGetServiceKeysQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetServiceKeysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetServiceKeysQuery({
 *   variables: {
 *   },
 * });
 */ function useGetServiceKeysQuery(baseOptions) {
    var options = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, defaultOptions, baseOptions);
    return _apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .useQuery */ .a(GetServiceKeysDocument, options);
}
function useGetServiceKeysLazyQuery(baseOptions) {
    var options = _object_spread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(GetServiceKeysDocument, options);
}
var GetUserBookingsDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject16());
/**
 * __useGetUserBookingsQuery__
 *
 * To run a query within a React component, call `useGetUserBookingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserBookingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserBookingsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */ function useGetUserBookingsQuery(baseOptions) {
    var options = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, defaultOptions, baseOptions);
    return _apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .useQuery */ .a(GetUserBookingsDocument, options);
}
function useGetUserBookingsLazyQuery(baseOptions) {
    var options = _object_spread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(GetUserBookingsDocument, options);
}
var GetUserFavPropIdsDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject17());
/**
 * __useGetUserFavPropIdsQuery__
 *
 * To run a query within a React component, call `useGetUserFavPropIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserFavPropIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserFavPropIdsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */ function useGetUserFavPropIdsQuery(baseOptions) {
    var options = _object_spread({}, defaultOptions, baseOptions);
    return Apollo.useQuery(GetUserFavPropIdsDocument, options);
}
function useGetUserFavPropIdsLazyQuery(baseOptions) {
    var options = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, defaultOptions, baseOptions);
    return _apollo_client__WEBPACK_IMPORTED_MODULE_5__/* .useLazyQuery */ .t(GetUserFavPropIdsDocument, options);
}
var GetUserFavPropertiesDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject18());
/**
 * __useGetUserFavPropertiesQuery__
 *
 * To run a query within a React component, call `useGetUserFavPropertiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserFavPropertiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserFavPropertiesQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */ function useGetUserFavPropertiesQuery(baseOptions) {
    var options = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, defaultOptions, baseOptions);
    return _apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .useQuery */ .a(GetUserFavPropertiesDocument, options);
}
function useGetUserFavPropertiesLazyQuery(baseOptions) {
    var options = _object_spread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(GetUserFavPropertiesDocument, options);
}
var GetUserProfileDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject19());
/**
 * __useGetUserProfileQuery__
 *
 * To run a query within a React component, call `useGetUserProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserProfileQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */ function useGetUserProfileQuery(baseOptions) {
    var options = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, defaultOptions, baseOptions);
    return _apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .useQuery */ .a(GetUserProfileDocument, options);
}
function useGetUserProfileLazyQuery(baseOptions) {
    var options = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, defaultOptions, baseOptions);
    return _apollo_client__WEBPACK_IMPORTED_MODULE_5__/* .useLazyQuery */ .t(GetUserProfileDocument, options);
}
var GetUserStatusDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject20());
/**
 * __useGetUserStatusQuery__
 *
 * To run a query within a React component, call `useGetUserStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserStatusQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */ function useGetUserStatusQuery(baseOptions) {
    var options = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, defaultOptions, baseOptions);
    return _apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .useQuery */ .a(GetUserStatusDocument, options);
}
function useGetUserStatusLazyQuery(baseOptions) {
    var options = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, defaultOptions, baseOptions);
    return _apollo_client__WEBPACK_IMPORTED_MODULE_5__/* .useLazyQuery */ .t(GetUserStatusDocument, options);
}
var RegisterUserDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject21());
/**
 * __useRegisterUserMutation__
 *
 * To run a mutation, you first call `useRegisterUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerUserMutation, { data, loading, error }] = useRegisterUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */ function useRegisterUserMutation(baseOptions) {
    var options = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, defaultOptions, baseOptions);
    return _apollo_client__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .D(RegisterUserDocument, options);
}
var RemoveUserFavPropertyDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject22());
/**
 * __useRemoveUserFavPropertyMutation__
 *
 * To run a mutation, you first call `useRemoveUserFavPropertyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveUserFavPropertyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeUserFavPropertyMutation, { data, loading, error }] = useRemoveUserFavPropertyMutation({
 *   variables: {
 *      propertyId: // value for 'propertyId'
 *      userId: // value for 'userId'
 *   },
 * });
 */ function useRemoveUserFavPropertyMutation(baseOptions) {
    var options = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, defaultOptions, baseOptions);
    return _apollo_client__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .D(RemoveUserFavPropertyDocument, options);
}
var ResendConfirmEmailDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject23());
/**
 * __useResendConfirmEmailMutation__
 *
 * To run a mutation, you first call `useResendConfirmEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendConfirmEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendConfirmEmailMutation, { data, loading, error }] = useResendConfirmEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */ function useResendConfirmEmailMutation(baseOptions) {
    var options = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, defaultOptions, baseOptions);
    return _apollo_client__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .D(ResendConfirmEmailDocument, options);
}
var ResetPasswordDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject24());
/**
 * __useResetPasswordMutation__
 *
 * To run a mutation, you first call `useResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordMutation, { data, loading, error }] = useResetPasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */ function useResetPasswordMutation(baseOptions) {
    var options = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, defaultOptions, baseOptions);
    return _apollo_client__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .D(ResetPasswordDocument, options);
}
var SaveUserFavPropertyDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject25());
/**
 * __useSaveUserFavPropertyMutation__
 *
 * To run a mutation, you first call `useSaveUserFavPropertyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveUserFavPropertyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveUserFavPropertyMutation, { data, loading, error }] = useSaveUserFavPropertyMutation({
 *   variables: {
 *      propertyId: // value for 'propertyId'
 *      userId: // value for 'userId'
 *   },
 * });
 */ function useSaveUserFavPropertyMutation(baseOptions) {
    var options = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, defaultOptions, baseOptions);
    return _apollo_client__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .D(SaveUserFavPropertyDocument, options);
}
var SearchPropertiesDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject26());
/**
 * __useSearchPropertiesQuery__
 *
 * To run a query within a React component, call `useSearchPropertiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchPropertiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchPropertiesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */ function useSearchPropertiesQuery(baseOptions) {
    var options = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, defaultOptions, baseOptions);
    return _apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .useQuery */ .a(SearchPropertiesDocument, options);
}
function useSearchPropertiesLazyQuery(baseOptions) {
    var options = _object_spread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(SearchPropertiesDocument, options);
}
var CreateNewPassportDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject27());
/**
 * __useCreateNewPassportMutation__
 *
 * To run a mutation, you first call `useCreateNewPassportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNewPassportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNewPassportMutation, { data, loading, error }] = useCreateNewPassportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */ function useCreateNewPassportMutation(baseOptions) {
    var options = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, defaultOptions, baseOptions);
    return _apollo_client__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .D(CreateNewPassportDocument, options);
}
var UpdateUserAvatarDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject28());
/**
 * __useUpdateUserAvatarMutation__
 *
 * To run a mutation, you first call `useUpdateUserAvatarMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserAvatarMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserAvatarMutation, { data, loading, error }] = useUpdateUserAvatarMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      image: // value for 'image'
 *   },
 * });
 */ function useUpdateUserAvatarMutation(baseOptions) {
    var options = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, defaultOptions, baseOptions);
    return _apollo_client__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .D(UpdateUserAvatarDocument, options);
}
var UpdateUserProfileDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject29());
/**
 * __useUpdateUserProfileMutation__
 *
 * To run a mutation, you first call `useUpdateUserProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserProfileMutation, { data, loading, error }] = useUpdateUserProfileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */ function useUpdateUserProfileMutation(baseOptions) {
    var options = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, defaultOptions, baseOptions);
    return _apollo_client__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .D(UpdateUserProfileDocument, options);
}
var result = {
    possibleTypes: {}
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (result)));


/***/ })

}]);